const OFF_PLATFORM_NOTE_INFORMAL = 'Escribe tu mensaje aquí. NOTA- Si deseas llevar tu conversación fuera de TogetherWe, asegúrate de proporcionar tu información de contacto aquí.';
const OFF_PLATFORM_NOTE_FORMAL = 'Escriba su mensaje aquí. NOTA- Si desea continuar la conversación fuera de TogetherWe, asegúrese de proporcionar su información de contacto aquí.';

export const es = {
  // Language toggle
  language: {
    english: 'English',
    spanish: 'Español',
  },

  // Navigation
  nav: {
    news: 'Noticias',
    newsFeed: 'Noticias',
    events: 'Eventos Locales',
    eventCalendar: 'Calendario de Eventos',
    forums: 'Foros Comunitarios',
    resources: 'Recursos',
    mentalHealthResources: 'Recursos de Salud Mental',
    groups: 'Grupos',
    groupsDirectory: 'Directorio de Grupos',
    volunteers: 'Voluntariado',
    volunteerDirectory: 'Directorio de Voluntariado',
    providers: 'Proveedores',
    mentalHealthProviders: 'Proveedores de Salud Mental',
    residentDirectory: 'Directorio de Residentes',
    blog: 'Blog',
    blogArticles: 'Articulos del Blog',
    welcome: 'Bienvenido',
    about: 'Acerca de TogetherWe',
    ourWork: 'Nuestro Trabajo',
    donate: 'Donar',
    frequentQuestions: 'Preguntas Frecuentes',
    guidelinesLegal: 'Pautas y Legal',
    myProfile: 'Mi Perfil',
    myGroups: 'Mis Grupos',
    myEvents: 'Mis Eventos',
    menu: 'Menú',
    signIn: 'Iniciar Sesión',
    signUp: 'Registrarse / Iniciar Sesión',
    logOut: 'Cerrar Sesión',
  },

  // Create Button
  create: {
    create: 'Crear',
    post: 'Publicación de noticias',
    postDesc: 'Comparte con la comunidad',
    event: 'Evento',
    eventDesc: 'Crea un evento comunitario',
    volunteer: 'Oportunidad de Voluntariado',
    volunteerDesc: 'Publica una oportunidad de voluntariado',
    group: 'Grupo',
    groupDesc: 'Inicia un nuevo grupo comunitario',
    provider: 'Crear Proveedor',
    providerDesc: 'Agrega un proveedor de salud mental',
    blog: 'Artículo de Blog',
    blogDesc: 'Escribe un artículo para la comunidad',
    resource: 'Recurso',
    resourceDesc: 'Agrega un recurso útil',
    teamBio: 'Bio del Equipo',
    teamBioDesc: 'Agrega un miembro del personal o junta',
    programCard: 'Tarjeta de Programa',
    programCardDesc: 'Agregar una tarjeta de grupo de trabajo',
    partnersSection: 'Sección de Socios',
    partnersSectionDesc: 'Edita los logos de la página de Socios',
  },

  // Common
  common: {
    scrollFiltersLeft: 'Desplazar filtros a la izquierda',
    scrollFiltersRight: 'Desplazar filtros a la derecha',
    loading: 'Cargando...',
    search: 'Buscar...',
    cancel: 'Cancelar',
    save: 'Guardar',
    saving: 'Guardando...',
    delete: 'Eliminar',
    deleting: 'Eliminando...',
    edit: 'Editar',
    close: 'Cerrar',
    submit: 'Enviar',
    confirm: 'Confirmar',
    back: 'Atrás',
    next: 'Siguiente',
    previous: 'Anterior',
    viewAll: 'Ver Todo',
    view: 'Ver',
    seeMore: 'Ver Más',
    seeLess: 'Ver Menos',
    noResults: 'No se encontraron resultados',
    required: 'Requerido',
    optional: 'Opcional',
    all: 'Todos',
    free: 'Gratis',
    members: 'miembros',
    member: 'miembro',
    replies: 'respuestas',
    reply: 'Responder',
    likes: 'me gusta',
    like: 'Me gusta',
    views: 'vistas',
    comments: 'comentarios',
    comment: 'Comentar',
    share: 'Compartir',
    follow: 'Seguir',
    following: 'Siguiendo',
    unfollow: 'Dejar de seguir',
    join: 'Unirse',
    leave: 'Salir',
    pending: 'Pendiente',
    approved: 'Aprobado',
    rejected: 'Rechazado',
    admin: 'Administrador',
    editor: 'Editor',
    anonymous: 'Anónimo',
    characters: 'caracteres',
    minRead: 'min de lectura',
    justNow: 'ahora mismo',
    ago: 'hace',
    postedBy: 'Publicado por',
    writtenBy: 'Escrito por',
    title: 'Título',
    category: 'Categoría',
    confirmDelete: '¿Eliminar Blog?',
    deleteConfirmMessage: '¿Estás seguro de que quieres eliminar este blog? Esta acción no se puede deshacer.',
    filters: 'Filtros',
  },

  // Sidebar
  sidebar: {
    upcomingEvents: 'Próximos Eventos',
    noUpcomingEvents: 'No hay eventos próximos',
    viewAllEvents: 'Ver Todos los Eventos',
    mentalHealthServices: 'Servicios de Salud Mental',
    forumTopics: 'Temas del Foro',
    noForumTopics: 'No hay temas del foro',
    viewAllTopics: 'Ver todos los Temas',
    volunteerJobs: 'Trabajos Voluntarios',
    noVolunteerJobs: 'No hay trabajos voluntarios',
    viewAllJobs: 'Ver todos los Trabajos',
    gettingStarted: 'Comenzando',
    gettingStartedSubtitle: 'Todo lo que necesitas saber sobre esta plataforma.',
    communityGuidelines: 'Pautas de la Comunidad',
    frequentQuestions: 'Preguntas Frecuentes',
    aboutTogetherWe: 'Acerca de TogetherWe',
    popularGroups: 'Grupos Populares',
    noPopularGroups: 'Aún no hay grupos',
    viewAllGroups: 'Ver todos los Grupos',
    members: 'miembros',
    popularArticles: 'Artículos Populares',
    noPopularArticles: 'Aún no hay artículos',
    minRead: 'min de lectura',
    views: 'vistas',
  },

  // Crisis Banner
  crisis: {
    title: 'No estás solo/a. Hay ayuda disponible.',
    getHelp: 'Obtener Ayuda Ahora',
    findResources: 'Encontrar Recursos',
    advisory: 'No estás solo/a. Aunque esta plataforma es un espacio de conexión y recursos, no cuenta con monitoreo para apoyo en crisis y no sustituye la atención profesional. Si estás en crisis o necesitas ayuda inmediata, llama o envía un mensaje al 988, marca 911, o comunícate con tu línea local de crisis 208-788-3596 o el Apoyo Bilingüe: 208-578-4114.',
    advisoryBold: ['envía un mensaje al 988, marca 911', '208-788-3596', 'Apoyo Bilingüe: 208-578-4114.'],
    inappropriateLanguageWarning: 'Por favor, abstente de usar contenido inapropiado, de odio o gráfico en TogetherWe. No permitimos este tipo de contenido según nuestros términos de servicio.',
    inappropriateTitle: 'Contenido inapropiado',
    inappropriateAck: 'Entendido',
    inappropriateBannerWarning: 'Por favor, elimina el contenido inapropiado, de odio o gráfico antes de publicar.',
  },

  // Auth Modal
  auth: {
    createAccount: 'Crea tu cuenta',
    joinCommunity: 'Únete a la comunidad TogetherWe hoy',
    welcomeBack: 'Bienvenido/a de nuevo',
    signInToContinue: 'Inicia sesión para continuar',
    yourName: 'Tu nombre',
    email: 'Correo electrónico',
    password: 'Contraseña',
    confirmPassword: 'Confirmar contraseña',
    location: 'Ubicación',
    age: 'Edad',
    continueWithGoogle: 'Continuar con Google',
    continueWithApple: 'Continuar con Apple',
    orContinueWith: 'o continúa con correo',
    signUp: 'Registrarse',
    logIn: 'Iniciar sesión',
    signIn: 'Iniciar sesión',
    alreadyHaveAccount: '¿Ya tienes una cuenta?',
    dontHaveAccount: '¿No tienes una cuenta?',
    forgotPassword: '¿Olvidaste tu contraseña?',
    termsAgreement: 'Al registrarte, aceptas nuestros',
    termsOfService: 'Términos de Servicio',
    and: 'y',
    privacyPolicy: 'Política de Privacidad',
    communityGuidelines: 'Pautas de la Comunidad',
    consentLabel: 'He leído y acepto los',
    consentRequired: 'Debes aceptar los Términos, la Política de Privacidad y las Pautas de la Comunidad para continuar.',
    missingFieldsError: 'Error — Faltan campos obligatorios.',
    passwordRequirements: 'La contraseña debe tener al menos 8 caracteres',
    passwordMinLength: 'Al menos 10 caracteres',
    passwordReqNumber: 'Al menos un número',
    passwordReqSpecial: 'Al menos un carácter especial',
    passwordReqUppercase: 'Al menos una letra mayúscula',
    invalidEmail: 'Por favor ingresa un correo electrónico válido',
    passwordMismatch: 'Las contraseñas no coinciden',
    ageRequirement: 'Debes tener al menos 13 años',
    ageConfirmation16Plus: '18+ años de edad',
    ageConfirmation13to15: '13-17 años de edad',
    birthdate: 'Fecha de nacimiento',
    birthdateHelper: 'Requerido para edades de 13 a 17 años. Cuando cumplas 18 años, tu acceso se actualizará automáticamente.',
    birthdateFutureError: 'La fecha de nacimiento no puede ser en el futuro.',
    birthdateAgeRangeError: 'La fecha de nacimiento debe corresponder a una edad entre 13 y 17 años.',
    creatingAccount: 'Creando cuenta...',
    loggingIn: 'Iniciando sesión...',
    failedToCreateAccount: 'Error al crear la cuenta',
    invalidCredentials: 'Correo o contraseña inválidos',
    emailAlreadyRegistered: 'Este correo ya está registrado.',
    signInInstead: 'Inicia sesión',
    accountSuspended: 'Tu cuenta ha sido suspendida. Contacta a soporte.',
    profilePhoto: 'Foto de perfil',
    profilePhotoOptional: 'Opcional',
    uploadPhoto: 'Subir foto',
    changePhoto: 'Cambiar',
    resetPassword: 'Restablecer Contraseña',
    resetPasswordTitle: 'Restablece tu contraseña',
    resetPasswordDesc: 'Ingresa tu correo y te enviaremos un código para restablecer tu contraseña',
    sendCode: 'Enviar Código',
    sendingCode: 'Enviando...',
    verificationCode: 'Código de Verificación',
    enterCode: 'Ingresa el código de 6 dígitos enviado a tu correo',
    newPassword: 'Nueva Contraseña',
    resetPasswordButton: 'Restablecer Contraseña',
    resettingPassword: 'Restableciendo...',
    backToLogin: 'Volver al inicio de sesión',
    codeSent: '¡Código enviado! Revisa tu correo.',
    passwordResetSuccess: '¡Contraseña restablecida exitosamente! Ya puedes iniciar sesión.',
    invalidCode: 'Código inválido o expirado',
    codeExpired: 'Código expirado. Por favor solicita uno nuevo.',
    changePassword: 'Cambiar Contraseña',
    changePasswordTitle: 'Cambia tu contraseña',
    changePasswordDesc: 'Ingresa tu contraseña actual y elige una nueva',
    currentPassword: 'Contraseña Actual',
    currentPasswordPlaceholder: 'Ingresa tu contraseña actual',
    newPasswordPlaceholder: 'Ingresa tu nueva contraseña',
    confirmNewPassword: 'Confirmar Nueva Contraseña',
    confirmNewPasswordPlaceholder: 'Vuelve a ingresar tu nueva contraseña',
    passwordsDoNotMatch: 'Las nuevas contraseñas no coinciden',
    changePasswordButton: 'Cambiar Contraseña',
    changingPassword: 'Cambiando...',
    passwordChangedSuccess: '¡Contraseña cambiada exitosamente! Todas las demás sesiones han sido revocadas.',
    incorrectPassword: 'La contraseña actual es incorrecta',
    passwordRequirementsNotMet: 'La nueva contraseña no cumple con los requisitos',
    accountCreatedSuccess: '¡Cuenta creada exitosamente!',
    loginSuccess: '¡Inicio de sesión exitoso!',
  },

  // Home/News Page
  news: {
    title: 'Noticias',
    subtitle: 'Mantente al día con lo que pasa en tu comunidad',
    loadingNews: 'Cargando noticias...',
    noNews: 'Aún no hay publicaciones.',
    createFirst: 'Crea la primera publicación',
    reachedEnd: 'Has llegado al final',
    commentsUnavailable: 'No se pudieron cargar los comentarios. Actualiza la página para volver a intentarlo.',
    searchPlaceholder: 'Buscar noticias...',
    whatsOnYourMind: '¿Qué tienes en mente?',
    shareThoughts: 'Comparte tus pensamientos, actualizaciones o anuncios...',
    postingAsGroup: 'Publicando como Grupo (Opcional)',
    postingAsYou: 'Publicando como Tú',
    selectGroup: 'Selecciona un grupo para publicar en nombre de la organización',
    createPost: 'Publicar en Noticias',
    editPost: 'Editar Publicación',
    updatePost: 'Actualizar Publicación',
    shareWithCommunity: 'Comparte algo con la comunidad',
    updateYourPost: 'Actualiza tu publicación',
    postCreated: '¡Publicación creada exitosamente!',
    postUpdated: '¡Publicación actualizada exitosamente!',
    failedCreate: 'Error al crear la publicación',
    failedUpdate: 'Error al actualizar la publicación',
    deletePost: '¿Eliminar Publicación?',
    deleteConfirm: 'Esta acción eliminará esta publicación del feed. Un administrador puede deshacer esto.',
    imagesOptional: 'Imágenes (Opcional - Máx 10)',
    dragDropImages: 'Arrastra y suelta imágenes aquí, o haz clic para seleccionar',
    imagesAdded: 'imágenes agregadas',
    contentTooLong: 'Contenido demasiado largo',
  },
  // Events
  events: {
    title: 'Eventos Locales',
    subtitle: 'Descubre y únete a eventos próximos en tu comunidad',
    searchPlaceholder: 'Buscar eventos...',
    loadingEvents: 'Cargando eventos...',
    noEvents: 'No se encontraron eventos.',
    createEvent: 'Crear un Evento',
    eventName: 'Nombre del Evento',
    addEventName: 'Agrega el nombre de tu evento',
    eventPhoto: 'Foto del Evento',
    addPhoto: 'Agregar una foto',
    date: 'Fecha',
    eventType: 'Tipo de Evento',
    oneOff: 'Evento único',
    recurringDaily: 'Recurrente diario',
    recurringWeekly: 'Recurrente semanal',
    recurringBiWeekly: 'Recurrente quincenal',
    recurringMonthly: 'Recurrente mensual',
    startTime: 'Hora de Inicio',
    endTime: 'Hora de Fin',
    cost: 'Costo',
    enterTicketPrice: 'Ingresa el precio del boleto',
    freeEvent: 'Evento gratuito',
    locationLabel: 'Ubicación',
    enterLocation: 'Ingresa la ubicación del evento',
    bookingLink: 'Enlace de Reserva del Evento',
    bookingLinkPlaceholder: 'Si tienes una página de reservas, agrega el enlace aquí',
    addDetails: 'Agregar Detalles',
    describeEvent: 'Describe tu evento...',
    category: 'Categoría (Opcional)',
    selectCategory: 'Selecciona una categoría',
    eventAccess: 'Acceso al Evento',
    openToPublic: 'Abierto al Público',
    membersOnly: 'Solo Miembros',
    anyoneCanRSVP: 'Cualquiera puede confirmar asistencia a este evento',
    onlyMembersRSVP: 'Solo los miembros del grupo pueden confirmar asistencia',
    postingAsGroup: 'Publicando como Grupo',
    selectGroup: 'Selecciona un grupo',
    mustBeAdmin: 'Debes ser administrador o editor de un grupo para crear eventos',
    addEvent: 'Agregar Evento',
    creating: 'Creando...',
    eventCreated: '¡Evento creado exitosamente!',
    failedCreate: 'Error al crear el evento. Por favor intenta de nuevo.',
    errorCreating: 'Ocurrió un error al crear el evento.',
    pastDateError: 'La fecha del evento no puede ser en el pasado. Por favor selecciona una fecha futura.',
    fillDetails: 'Completa los detalles para crear un nuevo evento comunitario',
    upcomingEvents: 'próximos eventos',
    allDates: 'Todas las Fechas',
    thisMonth: 'Este Mes',
    filterByDate: 'Filtrar por fecha',
    resetFilters: 'Restablecer Todos los Filtros',
    searchShortcuts: 'Atajos de búsqueda',
    free: 'Gratis',
    eventImage: 'Imagen del evento',
    noUpcomingEvents: 'No hay próximos eventos',
    attending: 'asistiendo',
    viewEvent: 'Ver Evento',
    nextMonth: 'Mes Siguiente',
    loadMoreEvents: 'Cargar Más Eventos',
  },

  // Groups
  groups: {
    title: 'Directorio de Grupos',
    subtitle: 'Encuentra y únete a grupos que coincidan con tus intereses',
    searchPlaceholder: 'Buscar grupos...',
    loadingGroups: 'Cargando grupos...',
    noGroups: 'No se encontraron grupos.',
    createGroup: 'Crear un Grupo',
    groupName: 'Nombre del Grupo',
    enterGroupName: 'Ingresa el nombre del grupo',
    groupPhoto: 'Foto del Grupo',
    description: 'Descripción',
    describeGroup: 'Describe tu grupo...',
    categoryLabel: 'Categoría',
    acceptingMembers: 'Aceptando Nuevos Miembros',
    allowJoinRequests: 'Permitir que las personas soliciten unirse a este grupo',
    createGroupBtn: 'Crear Grupo',
    creating: 'Creando...',
    bringPeopleTogether: 'Crea un nuevo grupo comunitario para unir a las personas',
    orDragDrop: 'o arrastra y suelta',
    all: 'Todos',
    health: 'Salud',
    healthcare: 'Salud',
    community: 'Comunidad',
    nonprofit: 'Sin Fines de Lucro',
    education: 'Educación',
    educational: 'Educativo',
    religious: 'Religioso',
    other: 'Otro',
    allCategories: 'Todas las Categorías',
    browseGroups: 'Explora grupos para unirte',
    notMember: 'Aún no eres miembro de ningún grupo.',
    manageGroups: 'Administra e interactúa con tus grupos',
    noDescription: 'No hay descripción disponible.',
    members: 'miembros',
    upcomingEvents: 'próximos eventos',
    acceptingNewMembers: 'Aceptando nuevos miembros',
    groupIsFull: 'El grupo está lleno',
    removedFromFavorites: 'Eliminado de favoritos',
    addedToFavorites: '¡Agregado a favoritos!',
    addToFavorites: 'Agregar a favoritos',
    removeFromFavorites: 'Quitar de favoritos',
    categories: {
      outdoor: 'Aire Libre',
      culture: 'Cultura',
      business: 'Negocios',
      community: 'Comunidad',
      education: 'Educación',
      religious: 'Religioso',
      support: 'Apoyo',
      teens: 'Jóvenes',
      seniors: 'Adultos Mayores',
      families: 'Familias',
      singles: 'Solteros',
    },
  },

  // My Groups
  myGroups: {
    title: 'Mis Grupos',
    posts: 'Noticias',
    forum: 'Discusiones',
    events: 'Eventos',
    videos: 'Videos',
    jobs: 'Empleos',
    members: 'Miembros',
    loadingGroups: 'Cargando tus grupos...',
    signInToView: 'Por favor inicia sesión para ver tus grupos.',
    notMember: 'Aún no eres miembro de ningún grupo.',
    browseGroups: 'Explorar grupos para unirte',
    manageGroups: 'Administra e interactúa con tus grupos',
    groupSelectorLabel: 'Tus grupos',
    scrollGroupsLeft: 'Desplazar a los grupos anteriores',
    scrollGroupsRight: 'Desplazar a más grupos',
  },

  myEvents: {
    title: 'Mis Eventos',
    description: 'Haz seguimiento de los eventos a los que confirmaste asistencia.',
    loadingEvents: 'Cargando tus eventos...',
    failedToLoad: 'No se pudieron cargar tus eventos.',
    signInToView: 'Por favor inicia sesiÃ³n para ver tus eventos.',
    upcomingEvents: 'PrÃ³ximos Eventos',
    pastEvents: 'Eventos Pasados',
    noUpcomingEvents: 'AÃºn no tienes prÃ³ximos eventos',
    noUpcomingEventsDescription: 'Los eventos a los que confirmes asistencia con "Voy" aparecerÃ¡n aquÃ­.',
    noPastEvents: 'AÃºn no tienes eventos pasados',
    noPastEventsDescription: 'Los eventos a los que asististe aparecerÃ¡n aquÃ­ cuando su fecha haya pasado.',
    browseEvents: 'Explorar Eventos',
  },

  // Forums
  forums: {
    title: 'Foros Comunitarios',
    communityForums: 'Foros Comunitarios',
    searchPlaceholder: 'Buscar temas del foro...',
    loadingTopics: 'Cargando...',
    noTopics: 'No se encontraron temas',
    noTopicsFound: 'No se encontraron temas',
    askQuestion: 'Hacer Pregunta',
    askQuestionTitle: 'Hacer una Pregunta',
    enterQuestion: 'Ingresa tu pregunta y detalles a continuación.',
    enterQuestionDetails: 'Ingresa tu pregunta y detalles a continuación.',
    enterQuestionDetailsPlaceholder: 'Ingresa los detalles de tu pregunta',
    questionTitle: 'Título',
    enterQuestionTitle: 'Ingresa el título de tu pregunta',
    category: 'Categoría',
    categoryLabel: 'Categoría',
    selectCategory: 'Selecciona una categoría',
    details: 'Detalles',
    enterDetails: 'Ingresa los detalles de tu pregunta',
    ask: 'Preguntar',
    posting: 'Publicando...',
    questionPosted: '¡Tu pregunta ha sido publicada!',
    noReplies: 'Aún no hay respuestas',
    noRepliesYet: 'Aún no hay respuestas',
    shareThoughts: 'Comparte tus pensamientos...',
    selectUserToReply: 'Selecciona un usuario para responder...',
    replyingTo: 'Respondiendo a',
    replyTo: 'Responder a',
    replies: 'respuestas',
    reply: 'Responder',
    likes: 'me gusta',
    allCategories: 'Todas las Categorías',
  },

  // Volunteers
  volunteers: {
    title: 'Oportunidades de Voluntariado',
    searchPlaceholder: 'Buscar oportunidades de voluntariado...',
    loadingOpportunities: 'Cargando oportunidades...',
    noOpportunities: 'No se encontraron oportunidades de voluntariado.',
    createJob: 'Crear un Empleo',
    postOpportunity: 'Publica una nueva oportunidad de voluntariado para la comunidad',
    postingAs: 'Publicando como',
    selectGroupPlaceholder: 'Selecciona un grupo...',
    jobName: 'Nombre del Empleo',
    enterJobTitle: 'Ingresa el título del empleo',
    uploadPhoto: 'Subir Foto',
    chooseFile: 'Elegir Archivo',
    pngJpgLimit: 'JPG, JPEG o PNG hasta 5MB',
    descriptionLabel: 'Descripción',
    describeOpportunity: 'Describe la oportunidad de voluntariado',
    locationLabel: 'Ubicación',
    enterLocationPlaceholder: 'Ingresa la ubicación',
    startDate: 'Fecha de Inicio',
    endDate: 'Fecha de Fin',
    salary: 'Salario',
    salaryPlaceholder: 'ej., $15/hora o Voluntario',
    jobType: 'Tipo de Empleo',
    selectJobType: 'Selecciona el tipo de empleo',
    positionsNeeded: 'Posiciones Necesarias',
    howManyVolunteers: '¿Cuántos voluntarios necesitas para esta oportunidad?',
    applicationLink: 'Enlace de Aplicación (Opcional)',
    applicationLinkPlaceholder: 'https://ejemplo.com/aplicar',
    applicationLinkHelp: 'Si se proporciona, los solicitantes serán dirigidos a este enlace. De lo contrario, te contactarán por correo.',
    createJobBtn: 'Crear Empleo',
    jobCreated: '¡Empleo creado exitosamente!',
    failedCreate: 'Error al crear el empleo',
    all: 'Todos',
    weekly: 'Semanal',
    biWeekly: 'Quincenal',
    monthly: 'Mensual',
    weekends: 'Fines de Semana',
    flexible: 'Flexible',
    volunteersNeeded: 'voluntarios necesarios',
    volunteerNeeded: 'voluntario necesario',
    posted: 'Publicado',
    linkCopied: '¡Enlace copiado al portapapeles!',
    postOpportunityBtn: 'Publicar Oportunidad',
    position: 'posición',
    positions: 'posiciones',
    needed: 'necesarias',
    volunteerLabel: 'voluntario',
    volunteersLabel: 'voluntarios',
    frequencies: {
      oneTime: 'Una vez',
      daily: 'Diario',
      weekly: 'Semanal',
      biWeekly: 'Quincenal',
      monthly: 'Mensual',
      weekends: 'Fines de Semana',
      flexible: 'Flexible',
    },
  },

  // Providers
  providers: {
    title: 'Proveedores de Salud Mental',
    subtitle: 'Encuentra proveedores de salud mental en tu área',
    searchPlaceholder: 'Buscar proveedores por áreas de enfoque, población atendida o tipos de seguro…',
    loadingProviders: 'Cargando proveedores...',
    noProviders: 'No se encontraron proveedores.',
    allProviders: 'Todos los Proveedores',
    filterByType: 'Filtrar por tipo de paciente',
    createProvider: 'Crear un Proveedor',
    addToDirectory: 'Agrega un nuevo proveedor de salud mental al directorio',
    providerName: 'Nombre del Proveedor',
    enterProviderName: 'Ingresa el nombre del proveedor',
    uploadPhoto: 'Subir Foto',
    chooseFile: 'Elegir Archivo',
    pngJpgLimit: 'JPG, JPEG o PNG hasta 5MB',
    degrees: 'Títulos / Licencias',
    selectDegree: 'Selecciona título',
    yearsExperience: 'Años de Experiencia',
    enterYears: 'Ingresa años',
    languages: 'Idiomas',
    sessions: 'Sesiones',
    inPerson: 'Presencial',
    virtual: 'Virtual',
    acceptingPatients: 'Aceptando Nuevos Pacientes',
    waitlist: 'No acepta nuevos pacientes',
    specialties: 'Mis Especialidades',
    selectSpecialties: 'Selecciona especialidades',
    maxSpecialties: '(máx 3)',
    patients: 'Mis Pacientes',
    selectPatients: 'Selecciona tipos de pacientes',
    maxPatients: '(máx 4)',
    locationLabel: 'Ubicación',
    enterLocation: 'Ingresa la ubicación',
    phone: 'Teléfono',
    enterPhone: 'Ingresa el número de teléfono',
    email: 'Correo Electrónico',
    enterEmail: 'Ingresa el correo electrónico',
    websiteLinkUrl: 'URL del Sitio Web',
    sessionCost: 'Costo de Sesión, Escala Móvil y Becas',
    officeHours: 'Horario de Oficina',
    officeHoursPlaceholder: 'ej., Lun-Vie: 9:00 AM - 5:00 PM',
    officeAddress: 'Dirección de la Oficina',
    enterFullAddress: 'Ingresa la dirección completa',
    insuranceAccepted: 'Seguros Aceptados',
    typeToSearch: 'Escribe para buscar o agregar nuevo',
    about: 'Acerca de',
    aboutPlaceholder: 'Cuéntale a los pacientes potenciales sobre ti, tu enfoque y tu experiencia...',
    createProviderBtn: 'Crear Proveedor',
    providerCreated: '¡Proveedor creado exitosamente!',
    failedCreate: 'Error al crear el proveedor',
    yearsInPractice: 'años de práctica',
    acceptingNewPatients: 'Aceptando nuevos pacientes',
    notAcceptingPatients: 'No acepta nuevos pacientes',
    addToFavorites: 'Agregar a favoritos',
    removeFromFavorites: 'Quitar de favoritos',
    genderMale: 'Masculino',
    genderFemale: 'Femenino',
  },

  // Mental Health Resources
  resources: {
    title: 'Recursos',
    topicAreaFilter: 'Área Temática',
    populationFilter: 'Población',
    searchPlaceholder: 'Busca recursos por área temática o población atendida…',
    call: 'Llamar',
    visitResource: 'Sitio web',
  },

  // Blog
  blog: {
    title: 'Artículos del Blog',
    subtitle: 'Lee artículos e ideas de la comunidad',
    searchPlaceholder: 'Buscar artículos del blog...',
    loadingPosts: 'Cargando artículos del blog...',
    noPosts: 'No se encontraron artículos del blog.',
    createBlog: 'Crear Artículo de Blog',
    writeArticle: 'Escribe un artículo para la comunidad',
    blogTitle: 'Título',
    enterTitle: 'Ingresa el título del blog...',
    categoryLabel: 'Categoría',
    descriptionLabel: 'Descripción',
    briefSummary: 'Breve resumen del artículo del blog...',
    content: 'Contenido',
    writeContent: 'Escribe el contenido de tu blog aquí...',
    coverImage: 'Imagen de Portada (Opcional)',
    clickToUpload: 'Sube una foto',
    featuredArticle: 'Artículo Destacado',
    markAsFeatured: 'Marcar como Artículo Destacado',
    featuredHelp: 'Los artículos destacados aparecen prominentemente en la parte superior de la página del blog. Solo un artículo puede ser destacado a la vez.',
    saveAsDraft: 'Guardar como Borrador',
    publishBlog: 'Publicar Blog',
    saving: 'Guardando...',
    draftSaved: '¡Borrador del blog guardado exitosamente!',
    blogCreated: '¡Artículo del blog creado exitosamente!',
    failedCreate: 'No pudimos guardar tu publicación. Por favor intenta de nuevo.',
    uncategorized: 'Sin categoría',
    draft: 'BORRADOR',
    popularArticles: 'Artículos Populares',
    categories: 'Categorías',
    stayUpdated: 'Mantente Actualizado',
    getLatestInsights: 'Recibe las últimas novedades de la comunidad en tu correo.',
    subscribe: 'Suscribirse',
    thisIsFeatured: 'Este artículo es ahora el artículo destacado.',
    hideComments: 'Ocultar',
    showComments: 'Mostrar',
    comments: 'comentarios',
    commenters: 'comentaristas',
    unlikeArticle: 'Quitar me gusta de este artículo',
    likeArticle: 'Me gusta este artículo',
    likes: 'me gusta',
  },



  // My Profile
  profile: {
    title: 'Mi Perfil',
    editProfile: 'Editar Perfil',
    saveChanges: 'Guardar',
    saving: 'Guardando...',
    signInToView: 'Por favor inicia sesión para ver tu perfil.',
    name: 'Nombre',
    handle: 'Usuario',
    usernameCannotChange: 'El nombre de usuario no se puede cambiar',
    emailCannotChange: 'El correo electrónico no se puede cambiar',
    neighborhood: 'Vecindario',
    neighborhoodPlaceholder: 'Centro de Austin, TX',
    email: 'Correo Electrónico',
    allowContact: 'Permitir que las personas me contacten',
    deleteProfile: 'Eliminar Perfil',
    deleteProfileWarning: 'Eliminar permanentemente tu cuenta y todos los datos asociados.',
    deleteProfileWarningLong: 'Esta acción no se puede deshacer. Todos tus datos, publicaciones y actividad serán eliminados permanentemente.',
    deleteProfileConfirm: '¿Eliminar Tu Perfil?',
    confirmDelete: 'Eliminar Perfil',
    deleteProfileSuccess: 'Perfil eliminado exitosamente',
    deleteProfileFailed: 'Error al eliminar el perfil',
    about: 'Acerca de',
    aboutPlaceholder: 'Cuéntanos sobre ti...',
    providerAccount: 'Cuenta de Proveedor de Salud Mental',
    registeredProviderPrompt: 'Regístrate como proveedor de salud mental',
    npiVerifiedLabel: 'NPI Verificado',
    providerNumber: 'Número NPI',
    enterProviderNumber: 'Ingresa tu número NPI',
    verified: 'Verificado',
    providerVerified: '¡NPI verificado exitosamente!',
    providerVerifyFailed: 'Error al verificar el NPI',
    providerNumberVerified: 'Tu NPI ha sido verificado.',
    createProviderProfile: 'Crear Perfil de Proveedor',
    createProviderProfileDesc: 'Crea un perfil de proveedor para aparecer en el directorio de proveedores de salud mental.',
    npiVerification: {
      title: 'Verificar Número NPI',
      subtitle: 'Verifica tu Identificador Nacional de Proveedor para confirmar tus credenciales',
      enterNpi: 'Número NPI',
      npiHint: 'Identificador Nacional de Proveedor de 10 dígitos',
      zipLabel: 'Código Postal',
      zipHint: 'Ingrese el código postal de su consultorio',
      zipInvalid: 'Por favor ingrese un código postal válido de 5 dígitos',
      verify: 'Verificar NPI',
      verifying: 'Verificando con el Registro CMS...',
      invalidFormat: 'Formato de NPI inválido. Debe tener 10 dígitos.',
      notFound: 'No se encontró ningún proveedor con este número NPI.',
      timeout: 'La solicitud expiró. Por favor intenta de nuevo.',
      rateLimited: 'El registro está ocupado. Por favor intenta en unos minutos.',
      error: 'Ocurrió un error. Por favor intenta de nuevo.',
      tryAgain: 'Intentar de Nuevo',
      confirmSave: 'Confirmar y Guardar',
      since: 'Desde',
      notActive: 'Este NPI no está activo. Solo se pueden verificar NPIs activos.',
      successTitle: '¡Proveedor Verificado!',
      successMessage: 'Tu NPI ha sido verificado y guardado en tu perfil.',
      nameMismatch: 'El nombre en este NPI no coincide con el nombre de tu perfil. Por favor verifica que ingresaste el número NPI correcto.',
      zipCodeMismatch: 'La ubicación en este NPI no coincide con la ubicación de tu perfil. Aún puedes continuar si esto es correcto.',
    },
    emailNotifications: 'Preferencias de Notificaciones por Correo',
    chooseNotifications: 'Elige qué notificaciones por correo te gustaría recibir',
    dailySummary: 'Tu Resumen Diario',
    dailySummaryDesc: 'Un resumen diario de publicaciones de noticias y eventos',
    weeklySummary: 'Tu Resumen Semanal',
    weeklySummaryDesc: 'Un resumen semanal de publicaciones de noticias y eventos',
    groupUpdates: 'Novedades de Grupos',
    groupUpdatesDesc: 'Nuevas publicaciones y eventos de los grupos a los que te has unido',
    groupForumReplies: 'Respuestas del Foro de Grupos',
    groupForumRepliesDesc: 'Respuestas del foro de los grupos a los que te has unido',
    groupPostComments: 'Admin de Grupo – Comentarios en Publicaciones',
    groupPostCommentsDesc: 'Nuevos comentarios en el muro de noticias de tu grupo',
    groupMemberRequests: 'Admin de Grupo – Solicitudes de Miembros',
    groupMemberRequestsDesc: 'Nuevas solicitudes de miembros para tu grupo',
    myGroupsSection: 'Mis Grupos',
    noGroupsJoined: 'Aún no te has unido a ningún grupo',
    noDescription: 'No hay descripción disponible.',
    showGroupsLabel: 'Mostrar mis grupos en mi perfil',
    avatarUploading: 'Subiendo foto...',
    avatarUploadSuccess: '¡Foto de perfil actualizada!',
    avatarUploadFailed: 'Error al subir la foto',
  },

  // Users Page
  users: {
    title: 'Residentes',
    subtitle: 'Conecta con miembros de la comunidad',
    searchPlaceholder: 'Buscar por nombre, usuario o ubicación...',
    loading: 'Cargando residentes...',
    noResidents: 'No hay residentes disponibles en este momento.',
    noResultsFor: 'No se encontraron residentes que coincidan con',
    tryDifferent: 'Intenta con un término de búsqueda diferente.',
    group: 'grupo',
    groups: 'grupos',
    online: 'En línea',
  },

  // Help Page
  help: {
    title: 'Obtener Ayuda',
    searchPlaceholder: 'Buscar respuestas...',
    emergencyContacts: 'Contactos de Emergencia',
    faq: 'Preguntas Frecuentes',
    resources: 'Recursos',
    crisisLine: 'Línea de Crisis',
    available247: 'Disponible 24/7',
    call: 'Llamar',
    noResults: 'No se encontraron resultados para',
    tryDifferent: 'Intenta una búsqueda diferente o',
    contactSupport: 'contacta soporte',
    stillNeedHelp: '¿Aún necesitas ayuda?',
    supportTeam: 'Nuestro equipo de soporte está aquí para ayudarte con cualquier pregunta o problema que puedas tener.',
    liveChat: 'Chat en Vivo',
    emailSupport: 'Soporte por Email',
  },

  // About Page
  about: {
    title: 'Acerca de TogetherWe',
    description: 'Estamos construyendo el futuro de la conexión comunitaria. TogetherWe empodera a las personas para crear, descubrir y participar en comunidades significativas que impulsan cambios positivos en sus áreas locales y más allá.',
    supportMission: 'Apoya nuestra misión',
    supportDescription: 'TogetherWe depende del generoso apoyo financiero de personas como tú para mantener y expandir nuestros programas. Tus donaciones nos ayudan a proporcionar recursos comunitarios esenciales, organizar eventos impactantes, conectar voluntarios con oportunidades significativas y ofrecer servicios críticos de salud mental a quienes los necesitan. Cada contribución, sin importar el tamaño, hace una diferencia real en el fortalecimiento de nuestra comunidad.',
    makeDonation: 'Hacer una donación',
    ourMission: 'Nuestra Misión',
    missionText: 'Democratizar la construcción de comunidades proporcionando herramientas accesibles que permitan a cualquier persona crear, hacer crecer y mantener conexiones significativas. Creemos que las comunidades fuertes son la base del cambio social positivo.',
    ourVision: 'Nuestra Visión',
    visionText: 'Un mundo donde cada persona tenga acceso a comunidades que apoyen su crecimiento, amplifiquen su voz y les ayuden a crear un impacto positivo. Imaginamos vecindarios, ciudades y regiones conectadas a través de comunidades digitales prósperas.',
    byTheNumbers: 'En Números',
    mentalHealthLandscape: 'Entendiendo el panorama de la salud mental',
    strategicPlan: 'Nuestro Plan Estratégico',
    keyMilestones: 'Hitos clave de 2025 a 2030',
    ourStaff: 'Nuestro Equipo',
    peopleBehind: 'Las personas detrás de TogetherWe',
    ourBoard: 'Nuestra Junta',
    leadersGuiding: 'Líderes que guían TogetherWe',
    joinNewsletter: 'Únete a Nuestro Boletín',
    newsletterDesc: 'Recibe noticias mensuales y actualizaciones sobre todas las iniciativas en las que TogetherWe está involucrado.',
    enterEmail: 'ingresa tu email',
    viewArchive: 'Ver nuestro archivo de boletines anteriores.',
    ourStory: 'Nuestra Historia',
    ourTeam: 'Nuestro Equipo',
    ourPartners: 'Nuestros Socios',
    stayConnected: 'Mantente conectado con nuestra comunidad',
    subscribeBtn: 'Suscribirse',
  },

  // Modals
  modals: {
    provider: {
      title: 'Crear un Proveedor',
      subtitle: 'Agregar un nuevo proveedor de salud mental al directorio',
      createProvider: 'Crear un Proveedor',
      addNewProvider: 'Agregar un nuevo proveedor de salud mental al directorio',
      providerName: 'Nombre del Proveedor',
      enterProviderName: 'Ingresa el nombre del proveedor',
      uploadPhoto: 'Subir Foto',
      chooseFile: 'Elegir Archivo',
      pngJpgLimit: 'JPG, JPEG o PNG hasta 5MB',
      fileTypes: 'JPG, JPEG o PNG hasta 5MB',
      degrees: 'Títulos / Licencias',
      selectDegree: 'Seleccionar título',
      yearsOfExperience: 'Años de Experiencia',
      enterYears: 'Ingresa años',
      languages: 'Idiomas',
      english: 'Inglés',
      spanish: 'Español',
      sessions: 'Sesiones',
      inPerson: 'Presencial',
      virtual: 'Virtual',
      acceptingNewPatients: 'Aceptando Nuevos Pacientes',
      waitlist: 'No acepta nuevos pacientes',
      mySpecialties: 'Mis Especialidades',
      max: 'máx',
      selectSpecialties: 'Seleccionar especialidades',
      myPatients: 'Mis Pacientes',
      selectPatientTypes: 'Seleccionar tipos de pacientes',
      location: 'Ubicación',
      enterLocation: 'Ingresa ubicación',
      phone: 'Teléfono',
      enterPhone: 'Ingresa número de teléfono',
      email: 'Correo Electrónico',
      enterEmail: 'Ingresa dirección de correo',
      websiteLinkUrl: 'URL del Sitio Web',
      cost: 'Costo',
      sessionCost: 'Costo de Sesión, Escala Móvil y Becas',
      sessionCostPlaceholder: 'ej. $150, $100-$150 escala móvil, becas disponibles',
      officeHours: 'Horario de Oficina',
      officeHoursPlaceholder: 'ej., Lun-Vie: 9:00 AM - 5:00 PM',
      officeAddress: 'Dirección de Oficina',
      enterFullAddress: 'Ingresa dirección completa',
      insuranceAccepted: 'Seguros Aceptados',
      typeToSearch: 'Escribe para buscar o agregar nuevo',
      about: 'Acerca de',
      aboutPlaceholder: 'Cuéntale a los pacientes potenciales sobre ti, tu enfoque y tu experiencia...',
      gender: 'Género',
      genderMale: 'Masculino',
      genderFemale: 'Femenino',
      createProviderBtn: 'Crear Proveedor',
      creating: 'Creando...',
      providerCreated: '¡Proveedor creado exitosamente!',
      providerCreatedSuccess: '¡Proveedor creado exitosamente!',
      failedCreate: 'Error al crear proveedor',
      failedToCreate: 'Error al crear proveedor',
    },
    blog: {
      createBlogPost: 'Crear Publicación de Blog',
      writeArticle: 'Escribe un artículo para la comunidad',
      title: 'Título',
      enterBlogTitle: 'Ingresa el título del blog...',
      categories: 'Categorías',
      selectUpToFour: 'selecciona hasta 4',
      categoriesSelected: '{count} de 4 categorías seleccionadas',
      atLeastOneCategoryRequired: 'Se requiere al menos una categoría.',
      maxCategoriesReached: 'Puedes seleccionar hasta 4 categorías.',
      description: 'Descripción',
      briefSummary: 'Breve resumen de la publicación del blog...',
      content: 'Contenido',
      writeContent: 'Escribe el contenido de tu blog aquí...',
      youtubeUrl: 'URL de video (YouTube o Vimeo, Opcional)',
      youtubeUrlPlaceholder: 'Pega un enlace de YouTube o Vimeo para incrustarlo en este artículo',
      youtubeUrlHelp: 'Compatible con enlaces de YouTube (youtube.com, youtu.be) y Vimeo (vimeo.com).',
      invalidYoutubeUrl: 'Por favor ingresa una URL de YouTube o Vimeo válida',
      minRead: 'min de lectura',
      coverImage: 'Imagen de Portada (Opcional)',
      clickToUpload: 'Sube una foto',
      markAsFeatured: 'Marcar como Artículo Destacado',
      featuredDescription: 'Los artículos destacados aparecen prominentemente en la parte superior de la página del blog. Solo un artículo puede estar destacado a la vez.',
      nowFeatured: 'Este artículo es ahora el artículo destacado.',
      saveAsDraft: 'Guardar como Borrador',
      publishBlog: 'Publicar Blog',
      saving: 'Guardando...',
      creating: 'Creando...',
      draftSavedSuccess: '¡Borrador del blog guardado exitosamente!',
      blogCreatedSuccess: '¡Publicación del blog creada exitosamente!',
      failedToCreate: 'No pudimos guardar tu publicación. Por favor intenta de nuevo.',
      errorOccurred: 'Ocurrió un error. Por favor intenta de nuevo.',
    },
    event: {
      createEvent: 'Crear Evento',
      fillDetails: 'Completa los detalles del evento',
      postingAsGroup: 'Publicando como Grupo',
      selectGroup: 'Selecciona un grupo',
      selectGroupRequired: 'Selecciona un grupo para publicar este evento en su nombre',
      mustBeAdmin: 'Debes ser administrador o editor de un grupo para crear eventos',
      eventName: 'Nombre del Evento',
      addEventName: 'Agrega el nombre de tu evento',
      eventPhoto: 'Fotos del Evento',
      addPhoto: 'Agregar foto',
      date: 'Fecha',
      endDate: 'Fecha de Fin',
      eventType: 'Tipo de Evento',
      oneOff: 'Evento único',
      recurringDaily: 'Recurrente diario',
      recurringWeekly: 'Recurrente semanal',
      recurringBiWeekly: 'Recurrente quincenal',
      recurringMonthly: 'Recurrente mensual',
      startTime: 'Hora de Inicio',
      endTime: 'Hora de Fin',
      cost: 'Costo',
      costHint: 'Describe el costo con tus propias palabras — un precio, "Gratis", "Paga lo que puedas" o lo que prefieras.',
      costPlaceholder: 'ej. $25, Gratis, Paga lo que puedas, escala móvil',
      costRequired: 'Describe el costo antes de guardar.',
      location: 'Dirección Completa',
      enterLocation: 'Ingresa la Dirección Completa',
      bookingLink: 'Enlace de Reserva del Evento',
      bookingLinkPlaceholder: 'Si tienes una página de reservas, agrega el enlace aquí',
      addDetails: 'Agregar Detalles',
      describeEvent: 'Describe tu evento...',
      categoryOptional: 'Categoría (Opcional)',
      categoriesOptional: 'Categorías (Opcional)',
      selectUpToFour: 'Selecciona hasta 4',
      categoriesSelected: '{count} de 4 categorías seleccionadas',
      selectCategory: 'Selecciona una categoría',
      eventAccess: 'Acceso al Evento',
      openToPublic: 'Abierto al Público',
      membersOnly: 'Solo Miembros',
      anyoneCanRsvp: 'Cualquiera puede confirmar asistencia a este evento',
      onlyMembersRsvp: 'Solo los miembros del grupo pueden confirmar asistencia',
      addEvent: 'Agregar Evento',
      creating: 'Creando...',
      eventCreated: '¡Evento creado exitosamente!',
      failedCreate: 'Error al crear el evento. Por favor intenta de nuevo.',
      errorCreating: 'Ocurrió un error al crear el evento.',
      pastDateError: 'La fecha del evento no puede ser en el pasado. Por favor selecciona una fecha futura.',
      recurrenceEndRequired: 'Los eventos recurrentes requieren una fecha de fin.',
      recurrenceEndAfterStart: 'La fecha de fin debe ser igual o posterior a la fecha de inicio del evento.',
    },
    news: {
      createPost: 'Crear Publicación',
      editPost: 'Editar Publicación',
      shareWithCommunity: 'Comparte algo con la comunidad',
      updateYourPost: 'Actualiza tu publicación',
      postingAsGroup: 'Publicando como Grupo (Opcional)',
      postingAsGroupRequired: 'Publicando como Grupo *',
      postingAsYou: 'Publicando como tú mismo',
      selectGroup: 'Selecciona un grupo',
      selectGroupToPost: 'Selecciona un grupo para publicar en su nombre, o deja vacío para publicar como tú mismo',
      selectGroupRequired: 'Selecciona un grupo para publicar en su nombre',
      whatsOnYourMind: '¿Qué tienes en mente?',
      sharePlaceholder: 'Comparte algo con la comunidad...',
      characters: 'caracteres',
      contentTooLong: 'El contenido es demasiado largo',
      imagesOptional: 'Imágenes (Opcional)',
      max: 'máx',
      dragAndDrop: 'Haz clic o arrastra y suelta imágenes',
      imagesAdded: 'imágenes agregadas',
      createPostBtn: 'Crear Publicación',
      updatePost: 'Actualizar Publicación',
      creating: 'Creando...',
      updating: 'Actualizando...',
      postCreated: '¡Publicación creada exitosamente!',
      postUpdated: '¡Publicación actualizada exitosamente!',
      failedCreate: 'Error al crear la publicación. Por favor intenta de nuevo.',
      failedUpdate: 'Error al actualizar la publicación. Por favor intenta de nuevo.',
    },
    group: {
      createGroup: 'Crear Grupo',
      createGroupSubtitle: 'Inicia un nuevo grupo comunitario',
      groupName: 'Nombre del Grupo',
      enterGroupName: 'Ingresa el nombre del grupo',
      groupPhoto: 'Foto del Grupo',
      groupPhotos: 'Fotos del Grupo',
      groupAvatar: 'Ícono del Grupo',
      groupAvatarHint: 'Se muestra junto a tus publicaciones y como ícono del grupo',
      addPhoto: 'Agregar Foto',
      addAvatar: 'Agregar Ícono',
      orDragDrop: 'o arrastra y suelta',
      description: 'Descripción',
      describeGroup: 'Describe tu grupo...',
      aboutUs: 'Sobre Nosotros',
      tellUsMore: 'Cuéntanos más sobre tu grupo, su misión y qué pueden esperar los miembros...',
      category: 'Categoría',
      selectCategory: 'Seleccionar categoría',
      pickUpToCategories: 'Elige hasta {n} categorías',
      location: 'Ubicación',
      websiteLink: 'Enlace al Sitio Web',
      acceptingMembers: 'Aceptando Miembros',
      groupIsFull: 'Grupo Lleno',
      allowPeopleToJoin: 'Permitir que personas se unan a este grupo',
      // MWBI-890 — ver la nota en en.ts. Dos interruptores independientes
      // reemplazan el antiguo interruptor único Público/Privado.
      showMemberList: 'Mostrar Lista de Miembros',
      hideMemberList: 'Ocultar Lista de Miembros',
      showGroupEvents: 'Mostrar Eventos del Grupo',
      hideGroupEvents: 'Ocultar Eventos del Grupo',
      toggleMemberListAria: 'Ocultar la lista de miembros a quienes no son miembros',
      toggleGroupEventsAria: 'Ocultar los eventos del grupo a quienes no son miembros',
      toggleAcceptingMembersAria: 'Marcar el grupo como lleno',
      toggleApprovalModeAria: 'Aceptar automáticamente las solicitudes para unirse',
      groupVisibilityNote: 'Cada interruptor funciona por separado. Las listas ocultas solo se ocultan de quienes no son miembros: los miembros y los administradores del grupo siempre ven todo. Tu grupo sigue apareciendo en el directorio de cualquier manera, y puedes cambiar estas opciones en cualquier momento en el modo EDITAR.',
      manualReview: 'Revisión Manual',
      autoAccept: 'Aceptación Automática',
      memberApprovalNote: 'La Revisión Manual requiere que apruebes cada solicitud de unión. La Aceptación Automática permite que cualquiera se una de inmediato.',
      createGroupBtn: 'Crear Grupo',
      creating: 'Creando...',
      groupRulesLabel: 'Reglas del Grupo',
      rulesHint: '¡Puedes añadir tus propias reglas, pero aquí tienes algunas para comenzar!',
      defaultRulesText: "Cómo se ve la participación aquí:\n·          Sé respetuoso y ten conciencia comunitaria\n·          Mantén el contenido relacionado con la conexión y el bienestar mental\n·          Sé auténtico y participa con honestidad\n·          Respeta la privacidad y los límites personales\n·          Sé acogedor y ayuda a mantener la comunidad segura\n \nLo que no está permitido:\n·          Acoso, intimidación o comportamiento excluyente\n·          Discurso de odio o discriminación\n·          Suplantación de identidad o representación falsa\n·          Compartir información privada o interacciones inseguras\n·          Spam, contenido dañino o engañoso",
    },
    volunteer: {
      createJob: 'Crear Trabajo Voluntario',
      postNewOpportunity: 'Publica una nueva oportunidad de voluntariado',
      postingAs: 'Publicando como Grupo',
      selectGroup: 'Selecciona un grupo',
      nameOfJob: 'Nombre del Trabajo',
      enterJobTitle: 'Ingresa el título del trabajo',
      uploadPhoto: 'Subir Foto',
      chooseFile: 'Elegir Archivo',
      fileTypes: 'JPG, JPEG o PNG hasta 5MB',
      description: 'Descripción',
      describeOpportunity: 'Describe la oportunidad de voluntariado...',
      location: 'Ubicación',
      enterLocation: 'Ingresa la ubicación',
      startDate: 'Fecha de Inicio',
      endDate: 'Fecha de Fin',
      startTime: 'Hora de Inicio',
      endTime: 'Hora de Fin',
      salary: 'Compensación',
      salaryPlaceholder: 'ej., Voluntario, $15/hr',
      jobType: 'Tipo de Trabajo',
      selectJobType: 'Selecciona tipo de trabajo',
      positionsNeeded: 'Posiciones Necesarias',
      numberOfVolunteers: 'Número de voluntarios',
      howManyVolunteers: '¿Cuántos voluntarios necesitas?',
      applicationLink: 'Enlace de Aplicación',
      applicationLinkHelp: 'Enlace externo donde los voluntarios pueden aplicar',
      createJobBtn: 'Crear Trabajo',
      creating: 'Creando...',
      jobCreatedSuccess: '¡Trabajo voluntario creado exitosamente!',
      failedToCreate: 'Error al crear el trabajo voluntario. Por favor intenta de nuevo.',
      errorOccurred: 'Ocurrió un error. Por favor intenta de nuevo.',
    },
    communityGuidelines: {
      title: 'Centro Comunitario TogetherWe',
      subtitle: 'Un lugar para conectar, participar y fortalecer la comunidad en todo el Condado de Blaine.',
      lead: 'Al unirte, aceptas mantener este espacio respetuoso, seguro y acogedor para todos.',
      allowedHeading: 'Cómo se ve la participación aquí:',
      notAllowedHeading: 'Lo que no está permitido:',
      allowed: [
        'Ser respetuoso y pensar en la comunidad',
        'Mantener el contenido relacionado con la conexión y el bienestar mental',
        'Ser auténtico y participar con honestidad',
        'Respetar la privacidad y los límites personales',
        'Ser acogedor y ayudar a mantener la comunidad segura',
      ],
      notAllowed: [
        'Acoso, intimidación o conductas excluyentes',
        'Discurso de odio o discriminación',
        'Suplantación o representación falsa',
        'Compartir información privada o interacciones inseguras',
        'Spam, contenido dañino o engañoso',
      ],
      consentText: 'Al hacer clic en "Acepto" abajo, consiento seguir estos términos y condiciones, incluyendo el cumplimiento de todas las reglas, políticas y directrices aplicables asociadas con este servicio. Reconozco que mi uso de la plataforma está sujeto a estos términos y que el incumplimiento de los mismos puede resultar en acceso restringido o terminación de mi cuenta.',
      agreeBtn: 'Acepto',
      saving: 'Guardando...',
      viewFullLink: 'Ver las directrices comunitarias completas y todos los términos y condiciones',
      opensInNewTab: 'se abre en una pestaña nueva',
      saveError: 'No pudimos registrar tu aceptación. Por favor, inténtalo de nuevo.',
    },
    ageVerification: {
      title: 'Una pregunta rápida',
      lead: 'Te preguntamos tu edad para asegurarnos de que las protecciones de seguridad adecuadas estén activas para los usuarios más jóvenes. Si te registraste con Google, es posible que no se te haya hecho esta pregunta.',
      // The age label, both option labels, the "select one" error, the birthdate
      // label and its helper are deliberately NOT redefined here — this modal
      // reuses auth.age, auth.ageConfirmation13to15, auth.ageConfirmation16Plus,
      // errors.ageGroupRequired, auth.birthdate and auth.birthdateHelper so it
      // cannot drift from the signup form it mirrors.
      continueBtn: 'Continuar',
      saving: 'Guardando...',
      closeLabel: 'Cerrar',
      errors: {
        BIRTHDATE_REQUIRED: 'Por favor, ingresa tu fecha de nacimiento para continuar.',
        BIRTHDATE_INVALID: 'Esa fecha no parece correcta. Por favor, revísala e inténtalo de nuevo.',
        BIRTHDATE_IN_FUTURE: 'Esa fecha está en el futuro. Por favor, revísala e inténtalo de nuevo.',
        AGE_OUT_OF_RANGE: 'TogetherWe es para personas de 13 años en adelante. Por favor, revisa tu fecha de nacimiento.',
        SAVE_FAILED: 'No pudimos guardar tu respuesta. Por favor, inténtalo de nuevo.',
      },
    },
  },

  // Program Card modal
  translation: {
    sectionLabel: 'Espanol',
    statusAuto: 'Traducido automaticamente',
    statusManual: 'Manual: editado a mano',
    statusPartial: 'Traducido parcialmente',
    statusUnavailable: 'Traduccion no disponible',
    statusPending: 'Traduciendo...',
    explainAuto: 'Este texto en espanol se actualiza solo cuando editas el ingles.',
    explainManual: 'El espanol de este elemento ya no se actualiza cuando cambias el ingles.',
    explainPartial:
      'Algunos campos no se pudieron traducir. Los visitantes en espanol ven el texto en ingles.',
    explainUnavailable:
      'No pudimos traducir este elemento. Los visitantes en espanol ven el texto en ingles. Editalo y guardalo de nuevo para reintentar.',
    explainPending: 'La version en espanol se esta creando y aparecera en unos segundos.',
    editSpanish: 'Editar espanol',
    cancelEditSpanish: 'Cancelar ediciones en espanol',
    editWarning:
      'Si editas el espanol, se detienen las actualizaciones automaticas de este elemento. A partir de ahi lo mantienes a mano.',
    resetToAutomatic: 'Volver a automatico',
    resetHint: 'Borra tu texto en espanol y deja que la traduccion automatica se encargue otra vez.',
    notTranslated: 'Sin traducir todavia',
    markerLabel: 'Sin traduccion al espanol: los visitantes ven ingles',
    emptyValue: '- sin traducir -',
  },
  programCard: {
    modalTitle: 'Crear Tarjeta de Programa',
    tabLabel: 'Pestaña',
    tabPlaceholder: 'Selecciona una pestaña',
    titleLabel: 'Título',
    titlePlaceholder: 'Ingresa el título del programa',
    descriptionLabel: 'Descripción',
    descriptionPlaceholder: 'Ingresa la descripción del programa...',
    uploadPhoto: 'Subir Foto',
    chooseFile: 'Elegir Archivo',
    photoHint: 'PNG, JPG hasta 10MB',
    cancel: 'Cancelar',
    creating: 'Creando...',
    created: '¡Tarjeta de programa creada exitosamente!',
    updating: 'Actualizando...',
    updated: '¡Tarjeta de programa actualizada exitosamente!',
    failed: 'Error al crear la tarjeta de programa',
    editModalTitle: 'Editar Tarjeta de Programa',
    colorLabel: 'Color de la tarjeta',
    colors: {
      light: 'Claro',
      cream: 'Crema',
      sage: 'Salvia',
    },
    tabs: {
      collectiveImpact: 'Impacto Colectivo',
      ourPrograms: 'Nuestros Programas',
      fundingGrants: 'Financiamiento y Subvenciones',
      facilitatingSolutions: 'Facilitando Soluciones',
    },
  },

  // Errors and Validation
  errors: {
    somethingWentWrong: 'Algo salió mal',
    tryAgain: 'Por favor intenta de nuevo',
    networkError: 'Error de red. Por favor verifica tu conexión.',
    unauthorized: 'No estás autorizado para realizar esta acción',
    notFound: 'No encontrado',
    serverError: 'Error del servidor. Por favor intenta más tarde.',
    validationError: 'Por favor verifica tu entrada e intenta de nuevo',
    requiredField: 'Este campo es requerido',
    invalidFormat: 'Formato inválido',
    tooLong: 'Demasiado largo',
    tooShort: 'Demasiado corto',
    emailRequired: 'Por favor ingresa tu correo electrónico',
    emailInvalid: 'Por favor ingresa un correo electrónico válido',
    passwordRequired: 'Por favor ingresa una contraseña',
    passwordTooLong: 'La contraseña debe tener 72 caracteres o menos',
    nameRequired: 'Por favor ingresa tu nombre completo',
    locationRequired: 'Por favor selecciona tu ubicación',
    ageGroupRequired: 'Por favor selecciona tu grupo de edad',
    groupNameRequired: 'Por favor ingresa el nombre del grupo',
    groupNameTooLong: 'El nombre del grupo debe tener 100 caracteres o menos',
    groupCategoryRequired: 'Por favor elige al menos una categoría',
    groupAboutRequired: 'Por favor cuéntanos sobre tu grupo',
    groupDescriptionTooLong: 'La descripción debe tener 2000 caracteres o menos',
    confirmPasswordRequired: 'Por favor confirma la contraseña',
    bioTooLong: 'La biografía debe tener 2000 caracteres o menos',
    eventTitleTooLong: 'El título del evento debe tener 100 caracteres o menos',
    eventDescriptionTooLong: 'La descripción del evento debe tener 5000 caracteres o menos',
    blogTitleTooLong: 'El título debe tener 200 caracteres o menos',
    blogDescriptionTooLong: 'La descripción debe tener 200 caracteres o menos',
    blogContentTooLong: 'El contenido debe tener 50,000 caracteres o menos',
    forumTitleRequired: 'El título es obligatorio',
    forumCategoryRequired: 'La categoría es obligatoria',
    forumReplyRequired: 'El cuerpo de la respuesta es obligatorio',
  },

  // Copy for the not-found.tsx boundaries. Deliberately no "try again" string:
  // a missing page is a permanent failure, and React Standards 11.3 reserves a
  // retry affordance for retryable errors.
  notFoundPage: {
    title: 'Página no encontrada',
    description:
      'No pudimos encontrar esa página. Puede que el enlace esté incompleto, o que la página se haya movido o eliminado.',
    goHome: 'Ir al Inicio',
  },

  // Time
  time: {
    justNow: 'ahora mismo',
    minutesAgo: 'm',
    hoursAgo: 'h',
    daysAgo: 'd',
    minute: 'minuto',
    minutes: 'minutos',
    hour: 'hora',
    hours: 'horas',
    day: 'día',
    days: 'días',
    week: 'semana',
    weeks: 'semanas',
    month: 'mes',
    months: 'meses',
    year: 'año',
    years: 'años',
    ago: 'hace',
  },

  // Comments
  comments: {
    comment: 'comentario',
    comments: 'comentarios',
    more: 'más',
    noComments: 'Aún no hay comentarios',
    shareThoughts: 'Comparte tus pensamientos...',
    selectUserToComment: 'Selecciona un usuario para comentar...',
    replyingTo: 'Respondiendo a',
    replyTo: 'Responder a',
  },

  // Group Tabs
  groupTabs: {
    posts: 'Noticias',
    loadingPosts: 'Cargando publicaciones...',
    noPosts: 'Aún no hay publicaciones en {groupName}',
    checkBackForPosts: 'Vuelve más tarde para nuevas publicaciones.',
    mustBeMemberForum: 'Debes ser miembro para ver este foro',
    memberBenefits: 'Como miembro, puedes participar en todas las reuniones presenciales del grupo y conversaciones del foro.',
    startDiscussion: 'Iniciar Discusión',
    postToForum: 'Publicar en el foro de {groupName}.',
    enterTopicTitle: 'Ingresa el título del tema',
    selectCategory: 'Selecciona una categoría',
    details: 'Detalles',
    enterTopicDetails: 'Ingresa los detalles del tema',
    posting: 'Publicando...',
    post: 'Publicar',
    discussions: 'Discusiones',
    searchDiscussions: 'Buscar discusiones...',
    noDiscussions: 'Aún no hay discusiones en {groupName}',
    beFirstToStart: '¡Sé el primero en iniciar una conversación!',
    deleteTopicTitle: 'Eliminar Tema',
    deleteTopicConfirm: '¿Eliminar este tema? Esta acción no se puede deshacer.',
    deleteReplyTitle: 'Eliminar Respuesta',
    deleteReplyConfirm: '¿Eliminar esta respuesta? Esta acción no se puede deshacer.',
    mustBeMemberEvents: 'Debes ser miembro para ver los eventos',
    hiddenEventsTitle: 'Eventos Ocultos',
    onlyMembersCanViewEvents: 'Solo los miembros del grupo pueden ver estos eventos',
    upcomingEvents: 'Próximos Eventos',
    noUpcomingEvents: 'No hay próximos eventos en {groupName}',
    checkBackLater: '¡Vuelve más tarde para nuevos eventos!',
    mustBeMemberJobs: 'Debes ser miembro para ver las ofertas de trabajo',
    jobPostings: 'Ofertas de Trabajo',
    noJobPostings: 'Aún no hay ofertas de trabajo en {groupName}',
    checkBackForJobs: '¡Vuelve más tarde para nuevas oportunidades!',
    mustBeMemberVideos: 'Debes ser miembro para ver los videos',
    videos: 'Videos',
    noVideos: 'Aún no hay videos en {groupName}',
    checkBackForVideos: '¡Vuelve más tarde para nuevo contenido!',
    members: 'Miembros',
    searchMembers: 'Buscar miembros...',
    noMembersFound: 'No se encontraron miembros',
    viewProfile: 'Ver Perfil',
    replies: 'respuestas',
    reply: 'respuesta',
    views: 'vistas',
    view: 'vista',
    addReply: 'Agregar una respuesta...',
    selectUserToReply: 'Selecciona un usuario para responder...',
    replying: 'Respondiendo...',
    noRepliesYet: '¡Aún no hay respuestas. Sé el primero en responder!',
    replyingTo: 'Respondiendo a',
    posted: 'Publicado',
    edited: 'Editado',
    addVideo: 'Agregar Video',
    noVideosYet: 'Aún no hay videos',
    addFirstVideo: '¡Agrega el primer video!',
    invalidVideoUrl: 'URL de video inválida',
    invalidYoutubeUrl: 'Por favor ingresa una URL de YouTube o Vimeo válida',
    youtubeUrl: 'URL de video (YouTube o Vimeo)',
    titleOptional: 'Título (Opcional)',
    videoTitle: 'Título del video',
    adding: 'Agregando...',
    today: 'Hoy',
    oneDayAgo: 'Hace 1 día',
    daysAgo: 'días atrás',
    oneWeekAgo: 'Hace 1 semana',
    weeksAgo: 'semanas atrás',
    requested: 'Solicitado',
    joined: 'Se unió',
    accept: 'Aceptar',
    reject: 'Rechazar',
    memberRequests: 'Solicitudes de miembros',
    currentMembers: 'Miembros Actuales',
    noMembersYet: 'Aún no hay miembros',
    replyTo: 'Responder a',
    rejectModalTitle: 'Rechazar solicitud de miembro',
    rejectModalSubtitle: 'Enviar un mensaje de rechazo a {name}',
    rejectionReasonLabel: 'Motivo',
    rejectionReasonPlaceholder: 'Explica por qué se está rechazando esta solicitud...',
    rejectionReasonRequired: 'Por favor ingresa un motivo antes de rechazar esta solicitud.',
    cancel: 'Cancelar',
    rejectAndSend: 'Rechazar y Enviar Mensaje',
    sendingRejection: 'Enviando...',
    rejectSuccess: 'La solicitud de {name} ha sido rechazada y el mensaje de rechazo fue enviado.',
    rejectFailed: 'Error al rechazar miembro',
    rejectMessageFailed: 'La solicitud de {name} fue rechazada, pero no se pudo enviar el mensaje de rechazo. Inténtalo de nuevo.',
    sendEmail: 'Enviar Correo',
    selectedItems: 'seleccionados',
    selectAllMembers: 'Seleccionar todos los miembros actuales',
    selectMember: 'Seleccionar a {name}',
    bulkEmailModalTitle: 'Redactar Correo',
    bulkEmailModalSubtitle: 'Enviar un correo a los miembros del grupo seleccionados',
    bulkEmailSubject: 'Asunto',
    bulkEmailSubjectPlaceholder: 'Ingrese el asunto del correo...',
    bulkEmailMessage: 'Mensaje',
    bulkEmailMessagePlaceholder: OFF_PLATFORM_NOTE_INFORMAL,
    bulkEmailSend: 'Enviar',
    bulkEmailSending: 'Enviando...',
    bulkEmailValidationError: 'Por favor complete todos los campos requeridos',
    bulkEmailSent: 'Correo enviado a {sentCount} miembros',
    bulkEmailSendFailed: 'Error al enviar correo. Intente de nuevo.',
    bulkEmailForbidden: 'Debes ser admin del grupo o admin de MWBI para enviar correos.',
    ageTagAdult: 'Adulto',
    ageTagTeen: 'Joven',
    bulkRemove: 'Eliminar',
    bulkRemoveConfirm: '¿Eliminar {count} miembro(s) de este grupo?',
    bulkRemoveFailed: 'Error al eliminar miembro(s). Intente de nuevo.',
    roleUpdateSuccess: '{name} ahora es {role}',
    roleUpdateFailed: 'Error al actualizar el rol. Intente de nuevo.',
    lastAdminError: 'Se requiere al menos un administrador. Asigna otro administrador primero.',
  },
  groupDetail: {
    loginToFollow: 'Por favor inicia sesión para seguir grupos',
    unfollowed: 'Dejaste de seguir a {name}',
    nowFollowing: 'Ahora sigues a {name}',
    joinedGroup: '¡Te has unido al grupo!',
    joinRequestSent: '¡Solicitud enviada! Esperando aprobación del administrador.',
    failedToJoin: 'Error al unirse al grupo',
    loadingGroup: 'Cargando grupo...',
    groupNotFound: 'Grupo no encontrado',
    backToGroups: 'Volver a Grupos',
    founded: 'Fundado',
    upcomingEvents: 'Próximos Eventos',
    websiteLink: 'Enlace al Sitio Web',
    visitWebsite: 'Visitar sitio web',
    notAcceptingMembers: 'El grupo estÃ¡ lleno',
    requesting: 'Solicitando...',
    joinGroup: 'Unirse al Grupo',
    joinConfirmMessage: '¡Gracias por tu interés en unirte a nuestro grupo! Todos nuestros miembros deben aceptar las reglas del grupo. Una vez que hagas clic en Aceptar, el administrador del grupo podrá aprobar tu solicitud.',
    joinConfirmAgree: 'Aceptar',
    joinRequestCanceled: 'Solicitud cancelada',
    failedToCancelRequest: 'Error al cancelar solicitud',
    requestPending: 'Solicitud Pendiente',
    member: 'Miembro',
    unfollow: 'Dejar de Seguir',
    follow: 'Seguir',
    linkCopied: '¡Enlace copiado al portapapeles!',
    forum: 'Foro',
    jobs: 'Empleos',
    requested: 'Solicitado',
    joined: 'Se unió',
    editGroup: 'Editar Grupo',
    deleteGroup: 'Eliminar Grupo',
    groupUpdated: 'Grupo actualizado exitosamente',
    // MWBI-890 — ver la nota en en.ts.
    savingSettings: 'Guardando la configuración de tu grupo…',
    groupDeleted: 'Grupo eliminado exitosamente',
    failedToUpdate: 'Error al actualizar grupo',
    failedToDelete: 'Error al eliminar grupo',
    deleteConfirmTitle: 'Eliminar Grupo',
    deleteConfirmMessage: '¿Estás seguro de que deseas eliminar este grupo? Esta acción no se puede deshacer.',
    confirmDelete: 'Eliminar',
    saveChanges: 'Guardar Cambios',
    cancelEdit: 'Cancelar',
    aboutUs: 'Sobre Nosotros',
    groupRules: 'Reglas del Grupo',
    memberListHiddenTitle: 'Lista de miembros oculta',
    onlyMembersCanViewMemberList: 'Solo los miembros del grupo pueden ver la lista de miembros',
  },
  eventDetail: {
    loadingEvent: 'Cargando evento...',
    eventNotFound: 'Evento no encontrado',
    // Names an incomplete link as a cause: the address is the one thing a
    // reader can check for themselves, and a shortened one is exactly how a
    // live event became unreachable in #1429.
    eventNotFoundDescription:
      'Este evento no existe, o a su dirección web le falta una parte. Explora el calendario para encontrarlo.',
    backToEvents: 'Volver a Eventos',
    joinGroupToViewTitle: 'Únete al Grupo para Ver',
    joinGroupToViewDescription: 'Este evento es privado. Únete al grupo para acceder a los detalles completos del evento.',
    joinGroupToViewEvent: '“{eventTitle}” solo está disponible para miembros aprobados de este grupo.',
    membersOnly: 'Solo Miembros',
    membersOnlyRsvp: 'Este evento es solo para miembros del grupo. Únete al grupo para confirmar asistencia.',
    rsvpCancelled: 'Asistencia cancelada',
    rsvpConfirmed: '¡Asistencia confirmada!',
    failedToUpdateRsvp: 'Error al actualizar asistencia',
    invalidDateTime: 'Fecha u hora del evento inválida',
    removePhoto: 'Eliminar foto',
    updating: 'Actualizando...',
    cancelRsvp: 'Cancelar Asistencia',
    letFriendsKnow: 'Voy a ir',
    register: 'Registrarse',
    addToCalendar: 'Agregar al Calendario',
    organizedBy: 'Organizado Por',
    eventOrganizer: 'Organizador del Evento',
    aboutThisEvent: 'Acerca de Este Evento',
    eventAgenda: 'Agenda del Evento',
    accessibilityInfo: 'Información de Accesibilidad',
    location: 'Ubicación',
    moreEvents: 'Más Eventos',
    attendees: 'Asistentes',
    noAttendeesYet: 'Aún no hay asistentes',
    postEvent: 'Publicar en Noticias',
    editEvent: 'Editar Evento',
    deleteEvent: 'Eliminar Evento',
    saveChanges: 'Guardar Cambios',
    cancelEdit: 'Cancelar',
    eventUpdated: 'Evento actualizado exitosamente',
    eventDeleted: 'Evento eliminado exitosamente',
    failedToUpdate: 'Error al actualizar evento',
    failedToDelete: 'Error al eliminar evento',
    deleteConfirmTitle: '¿Eliminar Evento?',
    deleteConfirmMessage: '¿Estás seguro de que deseas eliminar este evento? Esta acción no se puede deshacer.',
    confirmDelete: 'Eliminar',
    recurrenceDeleteScopeTitle: 'Eliminar evento recurrente',
    recurrenceDeleteScopeDescription: 'Elige cuánto de esta serie recurrente deseas eliminar.',
    recurrenceEditScopeTitle: 'Actualizar evento recurrente',
    recurrenceEditScopeDescription: 'Elige cómo aplicar estos cambios a esta serie recurrente.',
    recurrenceScopeThisEvent: 'Este evento',
    recurrenceScopeThisEventDescription: 'Solo la ocurrencia seleccionada.',
    recurrenceScopeThisAndFuture: 'Este y todos los eventos futuros',
    recurrenceScopeThisAndFutureDescription: 'La ocurrencia seleccionada y cada ocurrencia posterior de esta serie.',
    recurrenceScopeSelectionRequired: 'Selecciona una opción antes de continuar.',
    recurrenceEnds: 'Se repite {frequency} hasta {endDate}',
    eventEnded: 'Este evento ya finalizó',
  },
  volunteerDetail: {
    opportunityNotFound: 'Oportunidad no encontrada.',
    backToVolunteers: 'Volver a Voluntariado',
    editOpportunity: 'Editar Oportunidad',
    editingOpportunity: 'Editando Oportunidad',
    noDescription: 'Sin descripción disponible.',
    contact: 'Contacto',
    currentContactInfo: 'Información de contacto actual',
    contactInfoManagedByProfile: 'Los datos de contacto vienen del perfil del usuario que publicó y no se editan aquí.',
    position: 'posición',
    positions: 'posiciones',
    needed: 'necesarias',
    oneTime: 'Una vez',
    posted: 'Publicado',
    updating: 'Actualizando...',
    applyNow: 'Aplicar Ahora',
    interested: 'RSVP',
    cancelInterested: 'Cancelar RSVP',
    interestConfirmed: '¡RSVP confirmado!',
    interestCancelled: 'RSVP cancelado',
    failedToUpdateInterest: 'Error al actualizar RSVP',
    interestedPeople: 'RSVPs',
    noInterestedYet: 'Aún no hay RSVPs',
    zeroInterested: '0 RSVPs',
    interestedCountLabel: 'RSVPs',
    interestedInApplying: '¿Interesado en aplicar?',
    contactOrganizerDirectly: 'Contacta al organizador directamente para aplicar a esta oportunidad:',
    deleteOpportunity: 'Eliminar Oportunidad',
    deleteOpportunityQuestion: '¿Eliminar Oportunidad?',
    deleteConfirmMessage: 'Esta acción eliminará esta oportunidad del listado. Esto puede ser revertido por un administrador.',
    opportunityUpdated: 'Oportunidad actualizada correctamente',
    failedToUpdate: 'Error al actualizar oportunidad',
    failedToDelete: 'Error al eliminar oportunidad',
    noContactInfo: 'No hay información de contacto disponible',
    applicationSubject: 'Solicitud',
    applicationBody: 'Hola,\n\nEstoy interesado en aplicar para "{title}" en {organization}.\n\nPor favor, háganme saber los próximos pasos.\n\n¡Gracias!',
    aboutOpportunity: 'Acerca de',
    location: 'Ubicación',
    forumTab: 'Foro',
    volunteersTab: 'Voluntarios',
    noVolunteersYet: 'Aún no hay voluntarios',
    volunteerSingular: 'voluntario',
    volunteerPlural: 'voluntarios',
  },
  providerDetail: {
    loadingProvider: 'Cargando proveedor...',
    providerNotFound: 'Proveedor no encontrado.',
    backToProviders: 'Volver a Proveedores',
    editListing: 'Editar Listado',
    yearsInPractice: 'años en práctica',
    virtual: 'Virtual',
    inPerson: 'Presencial',
    acceptingNewPatients: 'Aceptando nuevos pacientes',
    waitlist: 'No acepta nuevos pacientes',
    notAcceptingPatients: 'No acepta nuevos pacientes',
    mySpecialties: 'Mis Especialidades',
    myPatients: 'Mis Pacientes',
    phoneNumber: 'Número de Teléfono',
    email: 'Correo Electrónico',
    websiteLink: 'Enlace al Sitio Web',
    visitWebsite: 'Visitar Sitio Web',
    cost: 'Costo',
    sessionCost: 'Costo de Sesión, Escala Móvil y Becas',
    sessionCostPlaceholder: 'ej. $150, $100-$150 escala móvil, becas disponibles',
    officeHours: 'Horario de Oficina',
    officeAddress: 'Dirección de Oficina',
    insurance: 'Seguro',
    about: 'Acerca de',
    gender: 'Género',
    myGender: 'Mi Género',
    genderMale: 'Masculino',
    genderFemale: 'Femenino',
    favorite: 'Favorito',
    unfavorite: 'Quitar favorito',
    addedToFavorites: '¡Agregado a favoritos!',
    removedFromFavorites: 'Eliminado de favoritos',
  },
  blogDetail: {
    blogNotFound: 'Publicación no encontrada.',
    backToBlog: 'Volver al Blog',
    draft: 'BORRADOR',
    notPublishedYet: 'Esta publicación aún no está publicada',
    editDraft: 'Editar Borrador',
    editingDraft: 'EDITANDO BORRADOR',
    saveDraft: 'Guardar Borrador',
    saving: 'Guardando...',
    publish: 'Publicar',
    publishing: 'Publicando...',
    draftSaved: '¡Borrador guardado exitosamente!',
    failedToSaveDraft: 'Error al guardar borrador',
    blogPublished: '¡Blog publicado exitosamente!',
    failedToPublish: 'Error al publicar blog',
    deleteConfirm: '¿Estás seguro de que quieres eliminar esta publicación? Esta acción no se puede deshacer.',
    blogDeleted: '¡Blog eliminado exitosamente!',
    failedToDelete: 'Error al eliminar blog',
    errorOccurred: 'Ocurrió un error',
    coverImage: 'Imagen de Portada',
    coverPreview: 'Vista previa de portada',
    clickToUpload: 'Sube una foto',
    title: 'Título',
    titlePlaceholder: 'Título del blog...',
    description: 'Descripción',
    descriptionPlaceholder: 'Breve descripción...',
    content: 'Contenido',
    contentPlaceholder: 'Escribe el contenido de tu blog aquí...',
    youtubeUrl: 'URL de video (YouTube o Vimeo)',
    youtubeUrlPlaceholder: 'Pega un enlace de YouTube o Vimeo para incrustarlo en este artículo',
    youtubeUrlHelp: 'Compatible con enlaces de YouTube (youtube.com, youtu.be) y Vimeo (vimeo.com).',
    invalidYoutubeUrl: 'Por favor ingresa una URL de YouTube o Vimeo válida',
    featuredPost: 'Publicación destacada',
    nowFeatured: 'Este artículo es ahora el artículo destacado.',
    moreArticles: 'Más Artículos',
    blogUpdated: '¡Blog actualizado exitosamente!',
    failedToUpdate: 'Error al actualizar blog',
    editBlog: 'Editar Blog',
    editingBlog: 'Editando Blog',
    saveChanges: 'Guardar Cambios',
  },
  userDetail: {
    loadingProfile: 'Cargando perfil de residente...',
    userNotFound: 'Residente no encontrado. Por favor verifica la URL o regresa al directorio.',
    backToDirectory: 'Volver al Directorio',
    follow: 'Seguir',
    unfollow: 'Dejar de seguir',
    messageMe: 'Envíame un mensaje',
    loginToFollow: 'Por favor inicia sesión para seguir usuarios',
    nowFollowing: 'Ahora sigues a {name}',
    unfollowed: 'Dejaste de seguir a {name}',
    memberOf: 'Miembro de',
    group: 'Grupo',
    groups: 'Grupos',
    notMemberOfAnyGroups: '{name} aún no es miembro de ningún grupo',
    noDescription: 'Sin descripción disponible.',
    member: 'miembro',
    members: 'miembros',
    upcoming: 'próximos',
    event: 'evento',
    events: 'eventos',
    admin: 'Admin',
    editor: 'Editor',
    directMessage: {
      modalTitle: 'Enviar Mensaje',
      modalSubtitle: 'Enviar un correo directo a {name}',
      subject: 'Asunto',
      subjectPlaceholder: 'Ingrese el asunto del mensaje...',
      message: 'Mensaje',
      messagePlaceholder: OFF_PLATFORM_NOTE_FORMAL,
      send: 'Enviar Mensaje',
      cancel: 'Cancelar',
      sending: 'Enviando...',
      validationError: 'Por favor complete todos los campos requeridos',
      sent: 'Mensaje enviado a {name}',
      forbidden: 'No se puede enviar un mensaje a este usuario.',
      recipientNotFound: 'Destinatario no encontrado.',
      sendFailed: 'Error al enviar mensaje. Intente de nuevo.',
    },
  },
  attendees: {
    zeroAttending: '0 asistiendo',
    attending: 'asistiendo',
  },
  imageCarousel: {
    previousImage: 'Imagen anterior',
    nextImage: 'Siguiente imagen',
    goToImage: 'Ir a imagen {number}',
  },
  userSelector: {
    selectUser: 'Seleccionar Usuario',
    devSwitchUser: 'DEV: Cambiar Usuario',
    logOut: 'Cerrar Sesión',
  },
  userManagement: {
    title: 'Gestión de Usuarios',
    subtitle: 'Administrar usuarios, proveedores y grupos',
    allUsers: 'Todos los Usuarios',
    allProviders: 'Todos los Proveedores',
    allGroups: 'Todos los Grupos',
    tabs: {
      users: 'Usuarios',
      providers: 'Proveedores de Salud Mental',
      groups: 'Grupos',
      archived: 'Archivados',
    },
    searchPlaceholder: 'Buscar por nombre o ubicación...',
    searchPlaceholderUsers: 'Buscar por nombre, ubicación o tipo...',
    table: {
      name: 'Nombre',
      accountAge: 'Antigüedad',
      recentActivity: 'Actividad Reciente',
      past12Months: 'Últimos 12 meses',
      role: 'Rol',
      userType: 'Tipo de usuario',
      all: 'Todos',
      action: 'Acción',
      actions: 'acciones',
      featured: 'Destacado',
      featuredTooltip: 'Marcado como destacado para el resumen diario/semanal',
      notFeatured: 'No destacado',
    },
    activity: {
      high: 'Alta',
      medium: 'Media',
      low: 'Baja',
    },
    roles: {
      user: 'Usuario',
      blogWriter: 'Escritor de Blog',
      admin: 'Administrador',
      superadmin: 'Super Administrador',
    },
    status: {
      active: 'Activo',
      blocked: 'Bloqueado',
    },
    userType: {
      adult: 'Adulto',
      teen: 'Joven',
      unknown: 'Desconocido',
      unknownTooltip: 'Este usuario se registró antes de que pidiéramos la edad; se definirá en su próximo inicio de sesión',
    },
    actions: {
      select: 'Seleccionar',
      archive: 'Archivar',
      unarchive: 'Desarchivar',
      feature: 'Destacar este grupo',
      unfeature: 'Quitar destacado',
      unblock: 'Desbloquear Usuario',
      sendMessage: 'Enviar Mensaje',
      sendEmail: 'Enviar Correo',
      confirmAccount: 'Confirmar Cuenta',
      changePassword: 'Cambiar Contraseña',
    },
    badges: {
      unconfirmed: 'Sin Confirmar',
    },
    messages: {
      archiveSuccess: 'Archivado exitosamente',
      unarchiveSuccess: 'Desarchivado exitosamente',
      featureSuccess: 'Grupo marcado como destacado',
      unfeatureSuccess: 'El grupo ya no está destacado',
      unblockSuccess: 'Usuario desbloqueado exitosamente',
      roleUpdated: 'Rol actualizado exitosamente',
      errorUpdating: 'Error al actualizar',
      emailSent: 'Correo enviado a {sentCount} usuarios',
      emailSentWithFailures: 'Enviado a {sentCount}, fallidos: {failedCount}',
      emailValidationError: 'Por favor complete todos los campos requeridos',
      emailAdminRequired: 'Se requiere acceso de administrador',
      emailSendFailed: 'Error al enviar correo. Intente de nuevo.',
      directMessageSent: 'Mensaje enviado a {name}',
      directMessageForbidden: 'No se puede enviar un mensaje a este usuario.',
      directMessageRecipientNotFound: 'Destinatario no encontrado.',
      directMessageSendFailed: 'Error al enviar mensaje. Intente de nuevo.',
      accountConfirmed: 'Cuenta confirmada',
      confirmFailed: 'No se pudo confirmar la cuenta. Intente de nuevo.',
      confirmForbiddenTarget: 'No puede confirmar esta cuenta.',
      confirmNotFound: 'Usuario no encontrado.',
      passwordChanged: 'Contraseña cambiada',
      passwordChangeFailed: 'No se pudo cambiar la contraseña. Intente de nuevo.',
    },
    adminChangePassword: {
      title: 'Cambiar Contraseña',
      subtitle: 'Establecer una nueva contraseña para {name}',
      submit: 'Guardar Contraseña',
      cancel: 'Cancelar',
      fillAllFields: 'Por favor complete ambos campos',
      errors: {
        selfTarget: 'Use la configuración de su cuenta para cambiar su propia contraseña.',
        forbiddenTarget: 'No puede cambiar la contraseña de este usuario.',
        tooWeak: 'La contraseña debe tener al menos 10 caracteres e incluir una letra mayúscula, un número y un carácter especial.',
        userNotFound: 'Usuario no encontrado.',
      },
    },
    email: {
      modalTitle: 'Redactar Correo',
      modalSubtitle: 'Enviar un correo a los usuarios seleccionados',
      subject: 'Asunto',
      subjectPlaceholder: 'Ingrese el asunto del correo...',
      message: 'Mensaje',
      messagePlaceholder: OFF_PLATFORM_NOTE_INFORMAL,
      send: 'Enviar',
      cancel: 'Cancelar',
      sending: 'Enviando...',
    },
    directMessage: {
      modalTitle: 'Enviar Mensaje',
      modalSubtitle: 'Enviar un correo directo a {name}',
      subjectPlaceholder: 'Ingrese el asunto del mensaje...',
      messagePlaceholder: OFF_PLATFORM_NOTE_FORMAL,
      send: 'Enviar Mensaje',
      cancel: 'Cancelar',
      sending: 'Enviando...',
    },
    empty: {
      noUsers: 'No se encontraron usuarios',
      noProviders: 'No se encontraron proveedores',
      noGroups: 'No se encontraron grupos',
      noArchived: 'No hay elementos archivados',
    },
    confirmArchive: '¿Estás seguro de que deseas archivar los elementos seleccionados?',
    confirmUnarchive: '¿Estás seguro de que deseas desarchivar los elementos seleccionados?',
    selectedItems: 'seleccionados',
    yearsMonths: '{years} años {months} meses',
    yearMonths: '{years} año {months} meses',
    months: '{months} meses',
  },
  activityLog: {
    title: 'Registro de Actividad',
    subtitle: 'Rastrea todas las acciones de usuarios y administradores',
    searchPlaceholder: 'Buscar actividades...',
    user: 'Usuario',
    action: 'Acción',
    dateTime: 'Fecha y Hora',
    loadMore: 'Cargar más',
    noActivities: 'No se encontraron actividades',
    searchHint: 'Busca nombres y acciones en todo el registro. Máximo {max} caracteres.',
    noSearchResults: 'Ninguna actividad coincide con tu búsqueda.',
    showingCount: 'Mostrando {shown} de {total} actividades',
    loadError: 'No pudimos cargar el registro de actividad. Inténtalo de nuevo.',
    tryAgain: 'Intentar de nuevo',
  },
  flaggedItems: {
    title: 'Contenido Reportado',
    tabs: { posts: 'Posts', events: 'Eventos', groups: 'Grupos', providers: 'Proveedores', jobs: 'Empleos', forums: 'Foros' },
    columns: { title: 'Título', issue: 'Problema', action: 'Acción' },
    reports: 'reportes',
    approve: 'Aprobar',
    dismiss: 'Descartar',
    remove: 'Eliminar',
    flaggedBy: 'Reportado por',
    noItems: 'No hay contenido reportado',
    clickToView: 'Haz clic para ver',
    reasons: {
      inappropriate_language: 'Lenguaje inapropiado',
      harmful_content: 'Contenido potencialmente dañino',
      spam: 'Spam/Publicidad',
      self_harm: 'Mención de autolesión',
      misinformation: 'Desinformación médica',
      harassment: 'Acoso',
      other: 'Otro',
    },
    reportModal: {
      title: 'Reportar Contenido',
      subtitle: '¿Por qué reportas esto?',
      selectReason: 'Selecciona una razón',
      submit: 'Enviar Reporte',
      cancel: 'Cancelar',
      success: 'Reporte enviado. Gracias por ayudar a mantener segura a la comunidad.',
      error: 'Error al enviar reporte',
    },
  },
  // FAQs Page
  faqs: {
    title: 'Preguntas Frecuentes',
    subtitle: 'Encuentra respuestas a preguntas comunes sobre TogetherWe',
    searchPlaceholder: 'Buscar preguntas frecuentes...',
    categories: {
      platform: 'Plataforma TogetherWe',
      profile: 'Administrar mi perfil',
      community: 'Funciones comunitarias',
      groups: 'Funciones de grupos',
      mentalHealth: 'Funciones de salud mental',
    },
    platform: [
      {
        question: '¿Qué es la plataforma TogetherWe?',
        answer: 'TogetherWe es un centro comunitario para todos los residentes del Condado de Blaine. Aquí encontrarás todo tipo de grupos, organizaciones y actividades a las que puedes unirte. Conectarte con otros y construir comunidad es una excelente manera de mejorar tu bienestar mental cada día. Puedes obtener más información en las Preguntas Frecuentes de Grupos. Si tú o tu familia necesitan ayuda profesional, encontrarás proveedores y recursos de salud mental que pueden ayudarte hoy.',
      },
      {
        question: '¿Quién puede usarla?',
        answer: 'Todos los residentes y organizaciones con sede en el Condado de Blaine. Eso incluye proveedores de servicios, escuelas, campamentos, equipos deportivos, grupos de apoyo, gobierno local, organizaciones sin fines de lucro y más.',
      },
      {
        question: '¿Cómo garantizan que la plataforma sea amigable y acogedora?',
        answer: 'Nuestras Pautas de Comunidad establecen la forma en que queremos que las personas usen la plataforma y los comportamientos que no están permitidos. Cualquier persona que no cumpla con nuestras pautas perderá su acceso a la plataforma.',
      },
      {
        question: '¿Están rastreando mi información?',
        answer: 'Solo rastreamos información por razones de optimización propia. Nunca vendemos tus datos privados y no usamos ningún dato para dirigirnos a ti. No tenemos ningún incentivo para usar tus datos.',
      },
      {
        question: '¿Qué edad se necesita para usar la plataforma?',
        answer: 'Queremos dar la bienvenida a todos, incluidos los adolescentes, a la plataforma. Dicho esto, la limitamos a usuarios de al menos 13 años de edad.',
      },
      {
        question: '¿Cómo protegen a los niños en la plataforma?',
        answer: 'Todos los usuarios menores de 18 años tienen protecciones adicionales en la plataforma. No pueden recibir ninguna comunicación privada directa de otros usuarios. Los usuarios menores de 16 años pueden unirse a grupos, pero no pueden crear un grupo, una publicación de noticias ni un evento. Y pueden ocultar en su página de perfil los grupos de los que son miembros.',
      },
      {
        question: '¿Qué hacen para que el contenido sea accesible para los hispanohablantes?',
        answer: 'Todo el contenido del sitio web que está integrado en la plataforma se traduce automáticamente mediante el botón de idioma inglés/español ubicado en la esquina superior derecha del sitio web. Para el contenido generado por los usuarios —como publicaciones del feed de noticias, eventos, descripciones de grupos, comentarios y otras contribuciones de la comunidad— los usuarios son responsables de proporcionar las traducciones al español que deseen. Recomendamos a las organizaciones y a los miembros de la comunidad publicar contenido tanto en inglés como en español siempre que sea posible para maximizar la accesibilidad y la participación.',
      },
    ],
    profile: [
      {
        question: '¿Cómo edito mi perfil?',
        answer: 'Ve a Mi Perfil. Haz clic o toca el botón EDITAR. Luego puedes editar tu foto, nombre y biografía aquí.',
      },
      {
        question: '¿Cómo elimino mi perfil?',
        answer: 'Ve a Mi Perfil. Haz clic o toca el botón EDITAR. Luego desplázate hacia abajo, por debajo de tus preferencias de notificación, y verás el botón para eliminar tu cuenta. ADVERTENCIA: Si eliminas tu cuenta, todos tus datos se perderán. Si alguna vez creas una cuenta en el futuro, empezarás de cero.',
      },
      {
        question: '¿Cómo administro mi privacidad?',
        answer: 'Si no deseas que otros vean a qué grupos perteneces, desplázate hacia abajo en tu perfil hasta tus grupos. A la derecha hay un interruptor que puedes activar o desactivar para ocultarlos de tu perfil.',
      },
      {
        question: '¿Cómo reporto contenido o comportamiento inapropiado?',
        answer: 'Todo el contenido —publicaciones, comentarios, eventos, grupos y proveedores de salud mental— tiene un botón de denuncia. Si haces clic o tocas el botón de bandera, puedes reportar contenido inapropiado a nuestros moderadores.',
      },
    ],
    community: [
      {
        question: '¿Cómo funciona el Feed de Noticias?',
        answer: 'Si eres miembro de un grupo o lo sigues, verás sus publicaciones primero. Luego, otras publicaciones se mostrarán en orden cronológico, con las más recientes en la parte superior. Puedes comentar cualquier publicación y responder a los comentarios de otros. Las publicaciones pueden enlazar directamente a eventos, grupos o sitios web externos. Puedes reportar publicaciones inapropiadas haciendo clic en el botón de bandera, lo que notificará a nuestro moderador.',
      },
      {
        question: '¿Cómo encuentro y me uno a Grupos?',
        answer: 'Ve al directorio de Grupos. Busca grupos o desplázate por los listados. Cuando encuentres uno que te parezca interesante, haz clic en su tarjeta para visitar la página del perfil del grupo.',
      },
      {
        question: '¿Cómo encuentro Eventos y confirmo asistencia?',
        answer: 'Ve al directorio de Eventos. Busca, filtra o navega por los Eventos. Haz clic en la tarjeta de un Evento para visitar la página de detalles. Si encuentras un evento al que vas a asistir, haz clic en el botón "Voy a ir". Esto guarda el evento en tu página Mis Eventos. Si el evento requiere entradas, haz clic en el botón "Registrarse" para visitar la página de venta de entradas.',
      },
      {
        question: '¿Cómo encuentro Artículos?',
        answer: 'Ve al directorio de Blog. Busca, filtra o navega por los artículos del blog. Haz clic en los que te interesen.',
      },
      {
        question: '¿Cómo puedo encontrar a mis amigos y vecinos?',
        answer: 'Ve al directorio de Residentes. Busca a tus amigos y vecinos por nombre. Si tienen una cuenta, su tarjeta aparecerá en los resultados.',
      },
    ],
    groupsFeatures: [
      {
        question: '¿Qué son los Grupos?',
        answer: 'Los grupos son espacios comunitarios donde residentes y organizaciones se conectan en torno a intereses, actividades o causas compartidas. Como miembro de un grupo, puedes participar en foros del grupo, asistir a eventos y recibir actualizaciones de los administradores.',
      },
      {
        question: '¿Quién puede crear un Grupo?',
        answer: 'Cualquier residente y cualquier organización puede crear un grupo; sin embargo, lo limitamos a usuarios mayores de 16 años que vivan en el Condado de Blaine. Crear un grupo conlleva cierta responsabilidad. Los administradores deben gestionar la conversación en el foro y asegurarse de que todos sean amables y respetuosos. Los grupos no deben usarse para actividades que vayan en contra de nuestras Pautas de Comunidad.',
      },
      {
        question: '¿Cómo se crea un Grupo?',
        answer: 'Simplemente haz clic o toca el botón blanco "+ Crear" en la barra superior y selecciona "Crear Grupo". Necesitarás un nombre y una descripción. CONSEJO: ¡Agrega fotos, la gente es visual! Y para que tu foto se vea lo mejor posible en la tarjeta de tu grupo, usa una relación de aspecto de 600x800 horizontal. Proporcionamos reglas básicas de conducta en tu descripción. Puedes agregar más, pero te pedimos que no las elimines. Los grupos públicos comparten sus eventos y lista de miembros; los grupos privados los ocultan.',
      },
      {
        question: '¿Cómo establezco reglas para mi Grupo?',
        answer: 'Establecer reglas claras garantiza un buen ambiente en el grupo. Si no sabes por dónde empezar, proporcionamos reglas básicas de conducta en cada descripción. Puedes agregar más, pero te pedimos que establezcas reglas con las que todos los miembros deban estar de acuerdo. Así, si alguien las incumple, puedes eliminarlo del grupo y todos entenderán por qué.',
      },
      {
        question: '¿Cómo invito a personas a unirse a mi Grupo?',
        answer: 'Si tienes una lista de correo de amigos o compañeros que quieres invitar, haz clic en el botón "Compartir" para copiar la URL de tu grupo y pégala en tu correo o mensaje de texto. Cualquier persona que visite la página de tu grupo puede hacer clic en el botón "Unirse".',
      },
      {
        question: '¿Cómo administro las comunicaciones de mi Grupo?',
        answer: 'Al crear un grupo, te conviertes en su administrador. Como tal, puedes crear publicaciones, crear eventos y aceptar o rechazar miembros. Los miembros con notificaciones por correo activadas recibirán automáticamente un resumen de publicaciones y eventos del grupo. Un grupo te brinda el poder de las redes sociales, boletines de correo y reuniones, ¡todo combinado!',
      },
      {
        question: '¿Cómo creo un Evento?',
        answer: 'Haz clic o toca el botón blanco "+ Crear" en la barra superior y selecciona "Crear Evento". Aparecerá un formulario. En la parte superior, selecciona el grupo en nombre del cual publicas. Completa el formulario con nombre, detalles, fechas y horas. CONSEJO: Al agregar fotos, para que tu primera foto se vea lo mejor posible en la tarjeta de tu evento, usa una relación de aspecto de 600x800 horizontal. Puedes crear un evento único o recurrente, y público o solo para miembros. Una vez creado, puedes publicarlo en el Feed de Noticias haciendo clic en "Publicar en el Feed de Noticias" en la página del evento.',
      },
      {
        question: '¿Cómo creo una Publicación de Noticias?',
        answer: 'Haz clic o toca el botón blanco "+ Crear" en la barra superior y selecciona "Crear Publicación". Aparecerá un formulario. Selecciona el grupo en nombre del cual publicas y agrega el mensaje que quieras. Puedes incluir enlaces copiándolos y pegándolos en el campo de texto. Asegúrate de compartir solo contenido apropiado según nuestras Pautas de Comunidad. CONSEJO: ¡Agrega fotos, la gente es visual!',
      },
      {
        question: '¿Cómo administro los miembros de mi Grupo?',
        answer: 'En la pestaña de miembros, puedes cambiar el estado de un miembro a administrador, otorgándole los mismos privilegios. Cualquier administrador puede enviar mensajes a uno o varios miembros del grupo. Los administradores también pueden eliminar a los miembros que no cumplan las reglas. Solo convierte en administradores a personas de confianza. Si quieres abandonar un grupo que iniciaste, necesitarás al menos otro administrador al que cederle el control.',
      },
      {
        question: '¿Puedo tener varios Grupos?',
        answer: '¡Sí! Puedes crear y unirte a tantos grupos como quieras. Creemos que tener múltiples grupos te convierte en un miembro activo de la comunidad y te ayuda a llevar una vida más plena.',
      },
      {
        question: '¿Qué es la página Mis Grupos?',
        answer: 'Para facilitar la gestión de tus grupos, diseñamos la página Mis Grupos. Esta página reúne todas las comunicaciones de tus grupos en un práctico lugar, tanto para los grupos que administras como para los que eres miembro.',
      },
      {
        question: '¿Cuáles son las mejores dimensiones de foto para las tarjetas de Grupos y Eventos?',
        answer: 'Si quieres que la imagen se vea mejor en las tarjetas, puedes recortarla con una relación de aspecto 3x4. Así, una imagen de 600x800px funcionaría bien.',
      },
      {
        question: 'Envía un correo a los miembros de tu Grupo',
        answer: 'Como administrador, puedes enviar un mensaje unidireccional a uno, algunos o todos tus miembros. Primero, ve a la pestaña de Miembros. Luego, haz clic en la casilla junto a su nombre para seleccionar a los miembros a los que quieres enviar el correo. Esto mostrará un botón "Enviar Correo". Cuando hagas clic en este botón, aparecerá una ventana emergente para completar el Asunto y el Mensaje y enviarlo. Ten en cuenta que los miembros no pueden responder a este correo, por lo que quizás quieras incluir tu información de contacto.',
      },
    ],
    mentalHealth: [
      {
        question: '¿Cómo encuentro un Proveedor de Salud Mental?',
        answer: 'Ve al directorio de Proveedores de Salud Mental. Busca, filtra o navega por las tarjetas de proveedores. Haz clic en una para ver su página. Puedes buscar de muchas maneras: por el seguro que aceptan, por especialidad, por género, por tipo de sesión (virtual o presencial) y si están aceptando nuevos pacientes.',
      },
      {
        question: '¿Cómo contacto a un Proveedor de Salud Mental?',
        answer: 'En su página de proveedor figura su información de contacto, generalmente correo electrónico o teléfono. También pueden incluir un sitio web donde puedes reservar una cita.',
      },
      {
        question: '¿Cómo encuentro Recursos de Salud Mental?',
        answer: 'Ve al directorio de Recursos de Salud Mental. Busca, filtra o navega por las tarjetas de recursos. Cuando buscas, obtendrás recursos y artículos relacionados con tu búsqueda. Las tarjetas de recursos tienen un enlace a un sitio web. Algunas también pueden incluir un número directo para llamar.',
      },
      {
        question: '¿Cómo obtengo ayuda ahora mismo?',
        answer: 'Si buscas ayuda inmediata, puedes encontrar apoyo en crisis en las primeras tarjetas del directorio de Recursos de Salud Mental.',
      },
      {
        question: '¿Cómo me registro como Proveedor de Salud Mental?',
        answer: 'Si eres un Proveedor de Salud Mental, ve a la página Mi Perfil y desplázate hasta el final. Allí encontrarás un cuadro con el título Regístrate como Proveedor de Salud Mental. Haz clic en el botón Verificar NPI y luego ingresa tu número NPI y código postal. NOTA: Tu número NPI, nombre y código postal deben coincidir con lo que aparece en el Registro NPI. Esto puede tardar unos segundos. Una vez verificado, tu estado en la aplicación se actualizará.',
      },
      {
        question: '¿Cómo creo una página de Proveedor de Salud Mental?',
        answer: 'Una vez que estés registrado como Proveedor de Salud Mental, puedes crear tu página. Simplemente haz clic en el botón Crear en la barra superior. Deberías ver Página de Proveedor como una opción: haz clic en ella para abrir el formulario. El formulario te pedirá varios elementos, como una foto, tus licencias y títulos, especialidades y los seguros que aceptas. Una vez que ingreses toda tu información y la envíes, deberías ver tu página de Proveedor. Revísala. Si quieres cambiar algo, simplemente haz clic en el botón Editar en la parte superior derecha de la página. Luego puedes agregar o cambiar cualquier cosa y guardar los cambios.',
      },
      {
        question: '¿Cuáles son las mejores dimensiones de foto para las tarjetas de Proveedor de Salud Mental?',
        answer: 'Si quieres que la imagen se vea mejor en las tarjetas, puedes recortarla con una relación de aspecto 3x4. Así, una imagen de 600x800px funcionaría bien.',
      },
    ],
  },

  // Guidelines & Legal page
  guidelinesLegal: {
    title: 'Pautas y Legal',
    lastUpdated: 'Última actualización',
    tabs: {
      communityGuidelines: 'Pautas de la Comunidad',
      terms: 'Términos y Condiciones',
      privacy: 'Política de Privacidad',
    },
  },

  // Site footer (MWBI-901). Labels only. The organization name, EIN, mailing
  // address and contact email are untranslated constants in
  // `frontend/src/lib/org-contact.ts` and must never move into this namespace.
  footer: {
    logoAlt: 'TogetherWe - Unidos por el Bienestar Mental',
    contactLabel: 'Contacto:',
    builtByLabel: 'Creado por:',
    copyright: 'Derechos de autor ©',
  },

  // Mirror of en.ts taxonomy — keep keys in sync.
  taxonomy: {
    common: {
      all: 'Todos',
    },
    groupCategories: {
      'arts-culture': 'Arte/Cultura',
      business: 'Negocios',
      community: 'Comunidad',
      education: 'Educación',
      games: 'Juegos',
      'health-wellness': 'Bienestar/Autocuidado',
      'hobbies-interests': 'Pasatiempos/Intereses',
      multicultural: 'Multicultural',
      nonprofit: 'Sin fines de lucro',
      'outdoor-recreation': 'Aire libre/Recreación',
      'pets-animals': 'Mascotas/Animales',
      'religion-spirituality': 'Religión/Espiritualidad',
      'social-activities': 'Actividades Sociales',
      'sports-fitness': 'Deportes/Ejercicio',
      'support-coaching': 'Apoyo/Acompañamiento',
      travel: 'Viajes',
      volunteering: 'Voluntariado',
    },
    providerFilters: {
      adhd: 'TDAH',
      adults: 'Adultos',
      anxiety: 'Ansiedad',
      'bipolar-disorder': 'Trastorno Bipolar',
      couples: 'Parejas',
      depression: 'Depresión',
      'eating-disorders': 'Trastornos Alimenticios',
      families: 'Familias',
      'grief-loss': 'Duelo/Pérdida',
      lgbtqia: 'LGBTQIA+',
      ocd: 'TOC',
      'otr-l': 'Ter. Ocupacional (OT)',
      'seniors-elderly': 'Adultos Mayores',
      'sexual-trauma': 'Trauma Sexual',
      'substance-use': 'Uso de Sustancias',
      'suicide-ideation': 'Ideación Suicida',
      'adolescents-teens': 'Adolescentes',
      'trauma-ptsd': 'Trauma/TEPT',
    },
    providerSpecialties: {
      Anxiety: 'Ansiedad',
      Depression: 'Depresión',
      'Trauma/PTSD': 'Trauma/TEPT',
      ADHD: 'TDAH',
      'Bipolar Disorder': 'Trastorno Bipolar',
      'Eating Disorders': 'Trastornos Alimenticios',
      'Substance Abuse': 'Abuso de Sustancias',
      'Substance Use': 'Uso de Sustancias',
      OCD: 'TOC',
      'Grief/Loss': 'Duelo/Pérdida',
      'Relationship Issues': 'Problemas de Pareja',
      'Family Therapy': 'Terapia Familiar',
      'Child & Adolescent': 'Niños y Adolescentes',
      'LGBTQ+': 'LGBTQ+',
      'LGBTQIA+': 'LGBTQIA+',
      'Sexual Trauma': 'Trauma Sexual',
      'Suicide Ideation': 'Ideación Suicida',
      Other: 'Otro',
    },
    resourceTopics: {
      crisis: 'Crisis',
      'death-and-dying': 'Muerte/Morir',
      'domestic-violence': 'Violencia Doméstica',
      'education-training': 'Educación/Capacitación',
      'financial-support': 'Apoyo Financiero',
      food: 'Alimentación',
      grief: 'Duelo/Pérdida',
      'higher-levels-of-mental-health-care': 'Niveles Superiores de Atención',
      housing: 'Vivienda',
      neurodiversity: 'Neurodiversidad',
      'substance-use': 'Uso de Sustancias',
      suicide: 'Suicidio',
      wellness: 'Bienestar/Autocuidado',
    },
    resourcePopulations: {
      adults: 'Adultos',
      'families-parents': 'Familias/Padres',
      'first-responders': 'Personal de Primera Respuesta',
      hispanic: 'Hispano/a',
      'latino-latina': 'Latino/Latina',
      'lgbtqia-plus': 'LGBTQIA+',
      'mental-health-providers': 'Proveedores de Salud Mental',
      seniors: 'Adultos Mayores',
      teens: 'Adolescentes',
      veterans: 'Veteranos',
    },
    resourceCategories: {
      adults: 'Adultos',
      crisis: 'Crisis',
      'death-and-dying': 'Muerte/Morir',
      'domestic-violence': 'Violencia Doméstica',
      'education-training': 'Educación/Capacitación',
      'families-parents': 'Familias/Padres',
      'financial-support': 'Apoyo Financiero',
      'first-responders': 'Personal de Primera Respuesta',
      food: 'Alimentación',
      grief: 'Duelo/Pérdida',
      'higher-levels-of-care': 'Niveles Superiores de Atención',
      hispanic: 'Hispano/a',
      housing: 'Vivienda',
      'latino-latina': 'Latino/Latina',
      'lgbtqia-plus': 'LGBTQIA+',
      'mental-health-providers': 'Proveedores de Salud Mental',
      neurodiversity: 'Neurodiversidad',
      seniors: 'Adultos Mayores',
      'substance-use': 'Uso de Sustancias',
      suicide: 'Suicidio',
      teens: 'Adolescentes',
      veterans: 'Veteranos',
      wellness: 'Bienestar/Autocuidado',
    },
    blogCategories: {
      adults: 'Adultos',
      'arts-culture': 'Arte/Cultura',
      'community-building': 'Comunidad',
      crisis: 'Crisis',
      'death-and-dying': 'Muerte/Morir',
      'domestic-violence': 'Violencia Doméstica',
      education: 'Educación/Capacitación',
      'en-espanol': 'en español',
      events: 'Eventos',
      families: 'Familias/Padres',
      'financial-support': 'Apoyo Financiero',
      'first-responders': 'Personal de Primera Respuesta',
      food: 'Alimentación',
      grief: 'Duelo',
      'higher-levels-of-care': 'Niveles Superiores de Atención',
      housing: 'Vivienda',
      lgbtq: 'LGBTQIA+',
      'mental-health': 'Salud Mental',
      multicultural: 'Multicultural',
      neurodiversity: 'Neurodiversidad',
      nonprofit: 'Sin fines de lucro',
      outdoor: 'Aire Libre/Recreación',
      religion: 'Religión/Espiritualidad',
      seniors: 'Adultos Mayores',
      'sports-fitness': 'Deportes/Ejercicio',
      'substance-use': 'Uso de Sustancias',
      suicide: 'Suicidio',
      'support-coaching': 'Apoyo/Acompañamiento',
      teens: 'Adolescentes',
      'together-we': 'TogetherWe',
      veterans: 'Veteranos',
      volunteer: 'Voluntariado',
      wellness: 'Bienestar/Autocuidado',
    },
    eventCategories: {
      adults: 'Adultos',
      'arts-culture': 'Arte/Cultura',
      community: 'Comunidad',
      'education-training': 'Educación/Capacitación',
      'family-friendly': 'Apto para Familias',
      free: 'Gratis',
      games: 'Juegos',
      kids: 'Niños',
      multicultural: 'Multicultural',
      nonprofit: 'Sin fines de lucro',
      outdoor: 'Aire Libre',
      pets: 'Mascotas',
      religion: 'Religión',
      seniors: 'Adultos Mayores',
      'substance-free': 'Libre de Sustancias',
      'support-coaching': 'Apoyo/Acompañamiento',
      teens: 'Adolescentes',
      volunteer: 'Voluntariado',
      'wellness-self-care': 'Bienestar/Autocuidado',
    },
  },
} as const;


